var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchangeSubAccountBg = function SvgExchangeSubAccountBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1620,
    height: 1080,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h1620v1080H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exchange-sub-account-bg_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1620 0H0v1080h1620V0Z",
    fill: "url(#exchange-sub-account-bg_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 1057.15c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .88.87.86 2.3 0 3.16Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1077.84c-.88.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.87 2.3-.87 3.16 0 .87.87.87 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16ZM1470.83 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.88-.86 2.3-.87 3.16 0 .88.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1067.5c-.88.87-2.3.86-3.16 0-.88-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.87 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 1067.5c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 896.18c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.872.86-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .87-.872.87-2.302 0-3.162ZM1409.27 896.18c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1421.59 896.18c-.88-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 896.18c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 896.18c-.88-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.872.87-2.302 0-3.162Z",
    stroke: "#BFBFBF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 906.514a2.234 2.234 0 0 0-3.16 0 2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1360.01 937.552a2.234 2.234 0 0 0-3.16 0 2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1421.59 906.514c-.88-.873-2.3-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.87 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 906.514c-.88-.873-2.3-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1458.52 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 916.86c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1470.83 916.86c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 927.206c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.83 927.206c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 937.552c-.88-.873-2.3-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1458.52 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 947.885c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1360.01 958.231c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162ZM1360.01 947.885c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 958.231c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 958.231c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1384.64 947.885c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 958.231c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 958.231c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 958.231c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 958.231c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1470.83 958.231c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 969.336c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.59 969.336c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 969.336c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1458.52 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.83 969.336c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 979.669c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 979.669c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1421.59 979.669c-.88-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 979.669c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 979.669c-.88-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1409.27 800.246c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 800.246c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.83 800.246c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.88.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1360.01 810.592c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.872 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 810.592c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.872 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 810.592c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1446.22 810.592c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.872 3.16 0 .87-.873.87-2.302 0-3.162ZM1458.52 810.592c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1470.83 810.592c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.88.86 2.3.872 3.16 0 .88-.873.86-2.302 0-3.162ZM1360.01 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 820.938c-.87-.873-2.3-.86-3.16 0a2.242 2.242 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 820.938c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.86.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 820.938c-.87-.873-2.3-.86-3.16 0a2.242 2.242 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 820.938c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1470.83 820.938c-.87-.873-2.3-.86-3.16 0a2.242 2.242 0 0 0 0 3.162c.88.873 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162ZM1360.01 831.284c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 766.678c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 777.024c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1360.01 787.358c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.872 3.16 0 .86-.873.86-2.302 0-3.162ZM1372.33 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1384.64 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 831.284c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.83 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 841.63a2.234 2.234 0 0 0-3.16 0 2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1421.59 841.63c-.88-.873-2.3-.873-3.16 0-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.87 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 841.63c-.88-.873-2.3-.873-3.16 0-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162ZM1360.01 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162ZM1372.33 851.963c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1384.64 851.963c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 851.963c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 851.963c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1360.01 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 862.309c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 862.309c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1396.96 862.309c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 873.414c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 873.414c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 873.414c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.872.86-2.301 0-3.162ZM1360.01 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 883.747c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 883.747c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 883.747c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 929.292a2.236 2.236 0 0 0-3.16 0c-.88.873-.86 2.302 0 3.162.86.861 2.3.861 3.16 0 .87-.872.87-2.301 0-3.162ZM1384.64 916.86c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 916.86c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 883.747c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1409.27 791.266c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 736.892a2.236 2.236 0 0 0-3.16 0c-.87.873-.87 2.29 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1409.27 747.238c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1409.27 757.584a2.236 2.236 0 0 0-3.16 0c-.86.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 767.93c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 727.912c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.59 883.747c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 883.747c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 883.747c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162ZM1446.22 873.414c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1458.52 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1470.83 883.747c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.872.86-2.301 0-3.162ZM1470.83 896.18c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.88.86 2.3.86 3.16 0 .88-.872.86-2.302 0-3.162ZM1470.83 873.414c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.88.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 896.18c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 896.18c-.88-.872-2.31-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 896.18c-.87-.872-2.29-.86-3.16 0-.87.86-.86 2.302 0 3.162.87.873 2.29.86 3.16 0 .88-.872.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1298.36 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.872.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.872.86-2.302 0-3.162Z",
    stroke: "#BFBFBF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 896.18c-.87-.872-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.62 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.872.87-2.302 0-3.162ZM1236.8 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 906.514c-.88-.873-2.3-.873-3.16 0-.86.872-.88 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 906.514a2.234 2.234 0 0 0-3.16 0 2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0 .88-.86.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1298.36 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .86-.86.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1335.31 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.88 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1347.62 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1236.8 916.86c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1215.29 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 906.514a2.234 2.234 0 0 0-3.16 0c-.88.872-.86 2.302 0 3.162.87.872 2.29.86 3.16 0 .87-.86.86-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 916.86c-.87-.873-2.29-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 916.86c-.88-.873-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 916.86c-.87-.873-2.29-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 916.86c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 916.86c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 916.86c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1347.62 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1236.8 927.206c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1249.12 927.206c-.88-.873-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1261.43 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 927.206c-.87-.873-2.29-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 927.206c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 927.206c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1236.8 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 937.552c-.88-.873-2.31-.873-3.16 0-.86.872-.88 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 937.552a2.234 2.234 0 0 0-3.16 0 2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162ZM1236.8 947.885c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1249.12 947.885c-.88-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1261.43 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1298.36 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1322.99 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 947.885c-.87-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1347.62 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 958.231c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1225.93 947.885c-.87-.873-2.29-.86-3.16 0-.88.86-.86 2.302 0 3.162.87.873 2.29.86 3.16 0 .87-.86.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 958.231c-.87-.873-2.29-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 958.231c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 958.231c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1322.99 958.231c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 958.231c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1347.62 958.231c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 969.336c-.88-.873-2.31-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 969.336c-.87-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1335.31 990.142c-.87-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.62 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1261.43 979.669c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1322.99 979.669c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 979.669c-.87-.872-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1347.62 979.669c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 800.246c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 800.246c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1286.05 800.246c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 800.246c-.87-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 810.592c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 810.592c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1286.05 810.592c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1298.36 810.592c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.872 3.16 0 .88-.873.88-2.302 0-3.162ZM1310.68 810.592c-.87-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1335.31 810.592c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1236.8 820.938c-.87-.873-2.3-.86-3.16 0a2.242 2.242 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 820.938c-.87-.873-2.29-.86-3.16 0-.88.873-.86 2.289 0 3.162.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1261.43 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 820.938c-.87-.873-2.29-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 820.938c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 820.938c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.86.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#C4C4C4",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 820.938c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1236.8 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1261.43 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 831.284c-.87-.873-2.29-.86-3.16 0-.87.86-.86 2.302 0 3.162.87.873 2.29.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 779.263c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 789.609c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 789.609c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 799.942c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.872.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 799.942c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.873 3.16 0 .86-.872.86-2.302 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1236.8 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1215.29 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 841.63c-.88-.873-2.3-.873-3.16 0-.86.873-.88 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1225.93 841.63a2.234 2.234 0 0 0-3.16 0c-.88.873-.86 2.302 0 3.162.87.873 2.29.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 841.63a2.234 2.234 0 0 0-3.16 0 2.25 2.25 0 0 0 0 3.162c.87.873 2.29.873 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1298.36 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1335.31 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.88 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1347.62 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162ZM1236.8 851.963c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1249.12 851.963c-.88-.873-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1261.43 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 851.963c-.87-.873-2.29-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 851.963c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1298.36 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.873.88-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 851.963c-.87-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1322.99 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 851.963c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1347.62 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1236.8 862.309c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 862.309c-.88-.872-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1225.93 862.309c-.87-.872-2.29-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.29.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 862.309c-.87-.872-2.29-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.873 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 862.309c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .88-.873.88-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 862.309c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1322.99 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.873 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 862.309c-.88-.872-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1347.62 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 873.414c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 873.414c-.88-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1249.12 758.432c-.88-.873-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 768.778c-.88-.873-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 779.124c-.88-.873-2.31-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1249.12 790.216c-.88-.873-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 873.414c-.87-.873-2.29-.86-3.16 0-.87.86-.86 2.302 0 3.162.87.873 2.29.873 3.16 0 .88-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.88-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 873.414c-.87-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.62 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 883.747c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 883.747c-.88-.872-2.31-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 883.747c-.87-.872-2.29-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.86 3.16 0 .88-.872.86-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 883.747c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .88-.872.88-2.301 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.98 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.29 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.872.86-2.301 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 883.747c-.87-.872-2.29-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 883.747c-.87-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .88-.872.86-2.301 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 883.747c-.88-.872-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1347.62 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.21 947.885c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1495.59 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 800.246c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 800.246c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 810.592c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.872 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 927.206c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 937.552c-.88-.873-2.3-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1483.19 969.336c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 800.246c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1483.19 782.109a2.245 2.245 0 0 0-3.16 0c-.88.872-.86 2.301 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 810.592c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.872 3.16 0 .87-.873.87-2.302 0-3.162ZM1483.19 820.938c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 831.284c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1483.19 841.63c-.88-.873-2.3-.873-3.16 0-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162ZM1483.19 791.266c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 883.747c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162ZM1483.19 873.414c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.83 1067.5c-.87.87-2.3.86-3.16 0-.87-.88-.87-2.31 0-3.17.88-.86 2.3-.86 3.16 0 .88.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1057.15c-.88.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16ZM1458.52 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1046.8c-.88.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.87 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1360.01 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .88.87.86 2.3 0 3.16ZM1360.01 1046.8c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 1036.46c-.87.87-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1384.64 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 1036.46c-.87.87-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1036.46c-.88.87-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1470.83 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.88-.86 2.3-.86 3.16 0 .88.87.86 2.3 0 3.16Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.64 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.87-2.31 0-3.17.87-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.86-.86 2.3-.86 3.16 0 .87.88.87 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.59 1006.26c-.88.87-2.3.86-3.16 0-.88-.88-.86-2.31 0-3.17.87-.87 2.3-.87 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1025.37c-.88.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.87 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.52 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.83 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.87-2.31 0-3.17.88-.86 2.3-.86 3.16 0 .88.88.86 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.33 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .86.86.87 2.3 0 3.16ZM1421.59 995.922c-.88.873-2.3.86-3.16 0-.88-.873-.86-2.302 0-3.162.87-.873 2.3-.86 3.16 0a2.25 2.25 0 0 1 0 3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.9 995.922c-.87.873-2.3.86-3.16 0-.87-.873-.87-2.302 0-3.162.87-.873 2.3-.86 3.16 0a2.25 2.25 0 0 1 0 3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.22 1015.02c-.88.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.87 2.3 0 3.16ZM1409.27 1068.17c-.87.87-2.3.86-3.16 0-.86-.86-.87-2.31 0-3.17.87-.86 2.3-.87 3.16 0 .86.88.86 2.31 0 3.17ZM1409.27 1057.83c-.87.88-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.01 1067.5c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.3-.86 3.16 0 .88.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 1065.41c-.87.87-2.3.87-3.16 0-.88-.87-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16ZM1384.64 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 1077.84c-.87.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.86-.86 2.3-.87 3.16 0 .87.87.87 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.27 1077.16c-.87.87-2.3.86-3.16 0-.86-.86-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 1034.36c-.87.87-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1298.36 1034.36c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .86.86.88 2.3 0 3.16ZM1286.05 1024.01c-.87.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1298.36 1024.01c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .88.87.88 2.3 0 3.16ZM1236.8 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16ZM1215.29 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.86-.86 2.3-.87 3.16 0 .88.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 1077.84c-.87.88-2.29.86-3.16 0-.88-.87-.86-2.3 0-3.16a2.24 2.24 0 0 1 3.16 0c.87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 1077.84c-.88.88-2.31.86-3.16 0-.88-.87-.88-2.3 0-3.16.87-.86 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 1077.84c-.87.88-2.29.86-3.16 0-.87-.87-.86-2.3 0-3.16a2.24 2.24 0 0 1 3.16 0c.88.87.86 2.3 0 3.16Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 1013.67c-.87.87-2.3.86-3.16 0a2.24 2.24 0 0 1 0-3.16c.87-.88 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 1013.67c-.87.87-2.3.86-3.16 0-.87-.88-.86-2.3 0-3.16.87-.88 2.3-.87 3.16 0 .88.87.88 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 1077.84c-.87.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.86-.86 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.86-.86 2.3-.87 3.16 0 .88.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 1077.84c-.88.88-2.3.86-3.16 0-.88-.87-.88-2.3 0-3.16.87-.87 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16ZM1347.62 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.87 3.16 0 .87.87.87 2.3 0 3.16ZM1236.8 1067.5c-.87.87-2.3.86-3.16 0-.87-.88-.87-2.31 0-3.17.87-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17ZM1249.12 1067.5c-.88.87-2.31.86-3.16 0-.88-.88-.88-2.31 0-3.17.87-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17ZM1261.43 1067.5c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 1067.5c-.87.87-2.29.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.29-.86 3.16 0 .88.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 1003.33c-.87.88-2.3.88-3.16 0-.86-.87-.86-2.3 0-3.16.87-.871 2.3-.859 3.16 0 .88.87.88 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 1067.5c-.87.87-2.3.86-3.16 0-.88-.88-.86-2.31 0-3.17.86-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 1067.5c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.86-.86 2.3-.86 3.16 0 .88.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 1067.5c-.88.87-2.3.86-3.16 0-.88-.88-.88-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17ZM1236.8 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 1057.15c-.88.87-2.31.86-3.16 0-.86-.86-.88-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 1057.15c-.87.87-2.29.86-3.16 0-.87-.86-.86-2.3 0-3.16.87-.87 2.29-.86 3.16 0 .88.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 992.988c-.87.872-2.3.86-3.16 0a2.25 2.25 0 0 1 0-3.162c.87-.873 2.3-.86 3.16 0 .86.86.88 2.302 0 3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .88.87.86 2.3 0 3.16ZM1236.8 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1249.12 1046.8c-.88.88-2.3.86-3.16 0-.86-.86-.88-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1261.43 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.88.86 2.3 0 3.16ZM1298.36 982.642c-.87.872-2.3.86-3.16 0a2.25 2.25 0 0 1 0-3.162c.87-.873 2.3-.86 3.16 0 .88.872.88 2.302 0 3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1322.99 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.88-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1347.62 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.87 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 982.553c-.87.873-2.3.86-3.16 0-.87-.873-.87-2.302 0-3.162.87-.86 2.3-.86 3.16 0a2.25 2.25 0 0 1 0 3.162ZM1225.93 1046.8c-.87.88-2.29.86-3.16 0-.88-.86-.86-2.3 0-3.16.87-.87 2.29-.86 3.16 0 .87.86.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.93 1036.46c-.87.87-2.29.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.88 2.29-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 972.295c-.87.873-2.3.873-3.16 0a2.25 2.25 0 0 1 0-3.162c.87-.872 2.3-.86 3.16 0 .88.873.88 2.302 0 3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 1036.46c-.87.87-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1322.99 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .88.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 1036.46c-.88.87-2.3.86-3.16 0-.88-.87-.88-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1347.62 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.12 1025.37c-.88.87-2.31.87-3.16 0-.86-.88-.88-2.31 0-3.17.87-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.43 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.86-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.99 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.86-.86 2.3-.86 3.16 0 .88.88.86 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.88-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17ZM1335.31 1004.55c-.87.87-2.3.86-3.16 0-.86-.86-.88-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.62 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.87 2.31 0 3.17ZM1261.43 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1322.99 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.31 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.88-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1347.62 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.87 2.3 0 3.16Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 1078.56c-.87.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1298.36 1078.56c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .88.87.88 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 1068.22c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.88 2.3-.88 3.16 0 .86.87.86 2.3 0 3.16Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 1068.22c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.88 2.3-.88 3.16 0 .86.87.88 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 1057.13c-.87.87-2.3.86-3.16 0-.88-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 1057.13c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.3-.86 3.16 0 .88.88.88 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.05 1046.78c-.87.87-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.36 1046.78c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.88 2.3-.86 3.16 0 .88.87.88 2.3 0 3.16ZM1495.59 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.59 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .86.86.87 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.86-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.21 972.295c-.88.873-2.3.873-3.16 0-.88-.872-.86-2.302 0-3.162.87-.872 2.3-.86 3.16 0a2.25 2.25 0 0 1 0 3.162ZM1495.58 982.654c-.89.86-2.3.848-3.16-.038a2.242 2.242 0 0 1 .03-3.162c.89-.86 2.31-.847 3.17.038.86.886.84 2.302-.04 3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.88 982.743a2.235 2.235 0 1 1-3.12-3.2 2.234 2.234 0 1 1 3.12 3.2Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.89 1004.5c-.87-.88-2.3-.88-3.16 0-.86.87-.86 2.3 0 3.16.86.86 2.3.86 3.16 0 .86-.86.86-2.3 0-3.16ZM1507.88 1017.9c-.89.86-2.3.85-3.16-.03-.86-.89-.85-2.31.04-3.17.88-.86 2.3-.84 3.16.04.86.89.84 2.3-.04 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 1067.5c-.88.87-2.3.86-3.16 0-.88-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.87 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.19 1057.15c-.88.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16ZM1483.17 982.566c-.88.86-2.3.847-3.16-.038a2.242 2.242 0 0 1 .04-3.162c.89-.86 2.3-.848 3.16.038.86.885.85 2.302-.04 3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 896.18c-.88-.872-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 896.18c-.88-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.872.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.872.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 896.18c-.88-.872-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.85.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1593.21 896.18c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 896.18c-.88-.872-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 896.18c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#BFBFBF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 906.514c-.88-.873-2.3-.873-3.16 0-.86.872-.88 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 906.514c-.88-.873-2.3-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 906.514c-.88-.873-2.31-.873-3.16 0-.86.872-.86 2.302 0 3.162.85.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1593.21 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 906.514c-.88-.873-2.31-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 906.514a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.29.86 3.16 0 .87-.86.86-2.302 0-3.162ZM1531.64 916.86c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1510.13 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.78 906.514c-.88-.873-2.31-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.78 916.86c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 916.86c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 916.86c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 916.86c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 916.86a2.258 2.258 0 0 0-3.17 0c-.87.872-.85 2.302 0 3.162.88.872 2.31.86 3.17 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 916.86c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 927.206c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1543.95 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1556.27 927.206c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 927.206c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 927.206a2.258 2.258 0 0 0-3.17 0c-.87.872-.85 2.302 0 3.162.88.872 2.31.86 3.17 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 927.206c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.872 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 937.552c-.88-.873-2.3-.873-3.16 0-.86.872-.88 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 937.552c-.88-.873-2.3-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 937.552c-.88-.873-2.31-.873-3.16 0-.86.872-.86 2.302 0 3.162.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 937.552a2.234 2.234 0 0 0-3.16 0c-.86.872-.86 2.302 0 3.162.87.872 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1531.64 947.885c-.88-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 1024.43c-.88-.87-2.3-.86-3.16 0-.86.86-.88 2.3 0 3.16.87.88 2.3.86 3.16 0 .87-.87.86-2.3 0-3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1556.27 947.885c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1593.21 947.885c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 947.885c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM1617.84 947.885c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.29.86 3.16 0 .87-.86.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.78 958.231c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 958.231c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 958.231a2.258 2.258 0 0 0-3.17 0c-.87.873-.85 2.302 0 3.162.88.873 2.31.86 3.17 0a2.25 2.25 0 0 0 0-3.162ZM1617.84 958.231c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.21 919.098c-.873-.872-2.302-.872-3.161 0-.86.873-.86 2.302 0 3.162.872.873 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.413 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.302.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.728 847.549a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM602.03 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.86.86 2.302.86 3.161 0 .86-.86.873-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.413 878.574a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.728 857.895a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.03 878.574a2.247 2.247 0 0 0-3.16 0 2.248 2.248 0 0 0 0 3.162c.859.86 2.301.86 3.16 0 .86-.86.873-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.413 888.92c-.872-.872-2.301-.872-3.161 0a2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM589.728 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.413 899.266a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.728 878.574a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM491.209 939.79a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM491.209 929.444a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.21 969.336a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.209 990.015a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.873 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.057 979.669a2.248 2.248 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162ZM491.209 1019.95a2.25 2.25 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.17 2.25 2.25 0 0 0 3.161 0c.873-.88.86-2.31 0-3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.524 934.617a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.873 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.839 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.872 2.302 0 3.162.873.86 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162ZM515.839 886.682a2.247 2.247 0 0 0-3.161 0c-.86.86-.872 2.302 0 3.162.873.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.154 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.86 2.302 0 3.162.86.86 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.469 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.872 2.302 0 3.162.872.873 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.413 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.859 2.302 0 3.162.873.873 2.302.873 3.161 0 .86-.872.86-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.728 888.92c-.872-.872-2.301-.872-3.161 0a2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM602.03 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.859 2.302 0 3.162.86.86 2.302.873 3.161 0 .86-.872.873-2.301 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.209 908.752a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.154 880.661a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162ZM515.839 868.241a2.247 2.247 0 0 0-3.161 0c-.86.86-.872 2.302 0 3.162.873.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.154 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.998 901.353c-.873-.872-2.301-.872-3.161 0-.86.873-.86 2.302 0 3.162.86.86 2.301.873 3.161 0 .86-.872.86-2.302 0-3.162ZM346.491 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.124 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.872 2.302 0 3.162.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.313 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.627 847.486a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.872 2.301.872 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.93 868.241a2.247 2.247 0 0 0-3.161 0c-.86.86-.873 2.302 0 3.162.872.873 2.301.86 3.161 0 .859-.86.872-2.302 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.244 868.241a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.559 831.284a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.874 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.872 2.302 0 3.162.873.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.189 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.504 847.549a2.247 2.247 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.872.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162ZM478.819 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162ZM367.998 911.687a2.247 2.247 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.86.86 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162ZM380.313 878.574a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162ZM392.627 857.832a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.872 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.93 878.574a2.248 2.248 0 0 0-3.161 0c-.873.873-.873 2.302 0 3.162.872.873 2.301.86 3.161 0 .859-.86.872-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.559 841.63c-.872-.873-2.301-.873-3.161 0-.859.873-.859 2.302 0 3.162.873.873 2.302.873 3.161 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.874 878.574a2.248 2.248 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.873.86 2.302.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.189 878.574a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.504 857.895a2.247 2.247 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.872.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162ZM367.998 922.033a2.247 2.247 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.86.86 2.301.872 3.161 0 .872-.873.859-2.29 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.313 888.92c-.873-.872-2.301-.872-3.161 0a2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.627 868.178a2.247 2.247 0 0 0-3.161 0c-.872.873-.859 2.289 0 3.162.873.873 2.302.873 3.161 0 .873-.873.86-2.289 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.93 888.92c-.873-.872-2.301-.872-3.161 0-.873.873-.873 2.302 0 3.162.872.873 2.301.86 3.161 0 .872-.872.872-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.559 851.963a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.874 888.92c-.872-.872-2.301-.872-3.161 0-.872.873-.872 2.302 0 3.162.873.86 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.189 888.92c-.873-.872-2.301-.872-3.161 0a2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162ZM367.998 932.379a2.246 2.246 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162ZM380.313 899.266a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162ZM392.627 878.511a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.16 0a2.248 2.248 0 0 0 0-3.162ZM429.559 862.309a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.873 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.874 899.266a2.248 2.248 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.873.86 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM454.189 899.266a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.504 878.574a2.248 2.248 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.872.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM478.819 899.266a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.998 942.725a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM357.124 899.266a2.248 2.248 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.124 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.872 2.302 0 3.162.873.873 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.559 872.655a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.874 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.872 2.302 0 3.162.873.86 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162ZM454.189 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.86 2.302 0 3.162.86.86 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.504 888.92c-.872-.872-2.301-.872-3.161 0-.872.873-.872 2.302 0 3.162.872.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162ZM478.819 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.86 2.302 0 3.162.872.873 2.301.873 3.161 0 .859-.872.859-2.301 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.786 888.92c-.872-.872-2.301-.872-3.161 0-.872.873-.872 2.302 0 3.162.873.86 2.302.86 3.161 0 .873-.872.873-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.786 899.266a2.248 2.248 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.873.86 2.302.86 3.161 0 .873-.872.873-2.302 0-3.162ZM626.786 927.395a2.248 2.248 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.873.86 2.302.873 3.161 0 .873-.872.873-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.089 899.266a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.404 899.266a2.248 2.248 0 0 0-3.161 0c-.873.873-.873 2.302 0 3.162.872.86 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162ZM614.383 878.574a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.383 888.92c-.872-.872-2.301-.872-3.161 0a2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.058 911.687a2.247 2.247 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.859.86 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM893.111 878.574a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 888.92c-.872-.872-2.301-.872-3.161 0a2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 818.699a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM872.249 829.045a2.247 2.247 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.86.86 2.301.873 3.161 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 839.379a2.246 2.246 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.138 899.266a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.86.86 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.058 932.379a2.246 2.246 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.859.86 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162ZM786.058 922.033a2.247 2.247 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.859.86 2.301.872 3.161 0 .872-.873.859-2.29 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.372 909.612a2.247 2.247 0 0 0-3.16 0c-.86.861-.873 2.302 0 3.162.872.86 2.301.873 3.16 0 .86-.872.873-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.687 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.859 2.302 0 3.162.873.873 2.302.873 3.161 0 .86-.872.86-2.301 0-3.162ZM810.687 899.266a2.247 2.247 0 0 0-3.16 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.16 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.002 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.859 2.302 0 3.162.873.873 2.301.873 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.317 909.612c-.872-.872-2.288-.86-3.161 0-.872.861-.86 2.302 0 3.162a2.235 2.235 0 0 0 3.161 0 2.238 2.238 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.86 2.302 0 3.162.86.86 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162ZM872.249 939.79a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 950.136c-.872-.872-2.301-.872-3.161 0a2.249 2.249 0 0 0 0 3.162c.86.861 2.301.861 3.161 0a2.249 2.249 0 0 0 0-3.162ZM872.249 1014.08a2.25 2.25 0 0 0-3.161 0c-.872.88-.86 2.31 0 3.17a2.25 2.25 0 0 0 3.161 0c.872-.88.86-2.31 0-3.17ZM872.249 1060c-.872-.88-2.301-.86-3.161 0-.872.87-.86 2.3 0 3.16.86.86 2.301.86 3.161 0 .872-.87.86-2.3 0-3.16ZM850.325 970.816a2.247 2.247 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.872.86 2.301.86 3.161 0 .86-.86.872-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 1044.92a2.25 2.25 0 0 0-3.161 0c-.872.87-.86 2.3 0 3.16.86.86 2.301.87 3.161 0 .86-.87.86-2.3 0-3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.249 981.162a2.247 2.247 0 0 0-3.161 0c-.872.872-.86 2.289 0 3.162.86.872 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.058 901.353c-.873-.872-2.301-.872-3.161 0-.86.873-.86 2.302 0 3.162.86.86 2.301.873 3.161 0 .859-.872.859-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.002 880.661a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM810.687 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.302.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.002 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.833 834.218a2.247 2.247 0 0 0-3.161 0c-.872.873-.872 2.302 0 3.162.873.873 2.289.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM641.327 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.972 868.241a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.16 0 .86-.86.873-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.148 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.463 898.596a2.247 2.247 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.778 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.093 844.552c-.873-.873-2.301-.873-3.161 0-.873.872-.86 2.289 0 3.161.86.873 2.301.861 3.161 0a2.249 2.249 0 0 0 0-3.161Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.408 868.241a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.859.86 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.722 849.725a2.246 2.246 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.161 2.246 2.246 0 0 0 3.161 0 2.247 2.247 0 0 0 0-3.161Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.037 868.241a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.339 836.457a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.872 2.301.872 3.16 0 .86-.873.873-2.302 0-3.162ZM773.654 849.788a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.872 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM773.654 829.045a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.873 3.161 0 .86-.873.86-2.302 0-3.162ZM662.833 844.552c-.872-.873-2.301-.873-3.161 0a2.237 2.237 0 0 0 0 3.161 2.246 2.246 0 0 0 3.161 0 2.247 2.247 0 0 0 0-3.161ZM675.148 878.574a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM687.463 908.942a2.247 2.247 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.778 878.574a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.408 878.574a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.86.86 2.301.86 3.161 0 .859-.86.859-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.722 810.592a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.872 2.302.872 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.037 878.574a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.86 3.161 0a2.26 2.26 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.34 878.574a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .859-.86.872-2.302 0-3.162ZM662.833 854.897a2.247 2.247 0 0 0-3.16 0c-.86.86-.873 2.302 0 3.162.872.873 2.288.86 3.16 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.148 888.92c-.872-.872-2.301-.872-3.161 0a2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.463 955.992a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.778 888.92c-.872-.872-2.301-.872-3.161 0a2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.249 2.249 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.408 983.4c-.873-.872-2.302-.872-3.161 0-.86.873-.86 2.302 0 3.162.859.86 2.301.873 3.161 0 .859-.872.859-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.722 867.482a2.247 2.247 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.037 1005.32a2.25 2.25 0 0 0-3.161 0c-.872.87-.859 2.3 0 3.16a2.25 2.25 0 0 0 3.161 0c.873-.87.86-2.3 0-3.16ZM662.833 865.243c-.872-.872-2.301-.872-3.16 0-.86.873-.873 2.302 0 3.162.872.873 2.288.86 3.16 0 .873-.86.86-2.302 0-3.162ZM675.148 899.266a2.248 2.248 0 0 0-3.161 0 2.249 2.249 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162ZM687.463 929.634a2.247 2.247 0 0 0-3.161 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM724.408 899.266a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.86.86 2.301.86 3.161 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.722 937.046a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.872 2.301.86 3.16 0a2.248 2.248 0 0 0 0-3.162ZM749.037 899.266a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.302.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.34 899.266a2.248 2.248 0 0 0-3.161 0 2.248 2.248 0 0 0 0 3.162c.872.873 2.301.86 3.161 0 .872-.872.872-2.302 0-3.162ZM773.654 942.725a2.247 2.247 0 0 0-3.161 0c-.859.86-.859 2.302 0 3.162.873.872 2.302.86 3.161 0a2.26 2.26 0 0 0 0-3.162ZM651.972 909.612a2.247 2.247 0 0 0-3.16 0c-.86.861-.86 2.302 0 3.162.872.873 2.301.873 3.16 0 .86-.872.873-2.301 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.408 909.612a2.248 2.248 0 0 0-3.161 0c-.86.861-.86 2.302 0 3.162.859.86 2.301.873 3.161 0 .859-.872.859-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.722 947.379a2.246 2.246 0 0 0-3.16 0 2.26 2.26 0 0 0 0 3.162c.872.873 2.301.86 3.16 0a2.26 2.26 0 0 0 0-3.162ZM749.037 909.612a2.248 2.248 0 0 0-3.161 0c-.859.861-.859 2.302 0 3.162.873.873 2.301.873 3.161 0 .86-.872.86-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.339 909.612a2.247 2.247 0 0 0-3.16 0c-.86.861-.86 2.302 0 3.162.872.873 2.301.873 3.16 0 .86-.872.873-2.301 0-3.162ZM773.654 880.661a2.248 2.248 0 0 0-3.161 0 2.25 2.25 0 0 0 0 3.162c.873.873 2.301.86 3.161 0a2.248 2.248 0 0 0 0-3.162Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 969.336c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 969.336c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 969.336c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1556.27 979.669c-.88-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1556.27 1024.43c-.88-.87-2.3-.86-3.16 0-.86.86-.86 2.3 0 3.16.87.88 2.3.86 3.16 0 .87-.87.87-2.3 0-3.16ZM1617.84 979.669c-.87-.872-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.29.86 3.16 0 .87-.86.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 800.246c-.88-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.872 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 800.246c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0 .86-.86.87-2.302 0-3.162ZM1580.9 800.246c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.85.86 2.3.86 3.16 0a2.26 2.26 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 810.592c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.872 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 810.592c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.87.872 2.3.872 3.16 0 .87-.873.87-2.302 0-3.162ZM1580.9 810.592c-.88-.873-2.3-.86-3.16 0-.88.872-.86 2.302 0 3.162.86.86 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1593.21 810.592c-.87-.873-2.3-.86-3.16 0-.87.872-.87 2.302 0 3.162.87.86 2.3.872 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1605.53 810.592a2.258 2.258 0 0 0-3.17 0c-.87.872-.85 2.302 0 3.162.88.872 2.31.872 3.17 0a2.25 2.25 0 0 0 0-3.162ZM1531.64 820.938c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.78 820.938c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162ZM1556.27 820.938c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 820.938c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 820.938c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.289 0 3.162.86.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 820.938c-.87-.873-2.3-.86-3.16 0a2.242 2.242 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 820.938a2.258 2.258 0 0 0-3.17 0c-.87.873-.85 2.289 0 3.162.88.873 2.31.86 3.17 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#C4C4C4",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 831.284c-.88-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1556.27 831.284c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 831.284c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.85.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 831.284c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 831.284c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 779.263c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 789.609c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 789.609c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.872 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 799.942c-.87-.872-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.872.86-2.302 0-3.162ZM1593.21 747.921c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 758.267a2.236 2.236 0 0 0-3.16 0c-.87.873-.87 2.29 0 3.162.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 768.601c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 799.942c-.88-.872-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.872.86-2.302 0-3.162Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 831.284c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 841.63c-.88-.873-2.3-.873-3.16 0-.86.873-.88 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1510.13 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.29.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1520.78 841.63c-.88-.873-2.31-.873-3.16 0-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 841.63c-.88-.873-2.3-.873-3.16 0-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 841.63c-.88-.873-2.31-.873-3.16 0-.86.873-.86 2.302 0 3.162.85.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162ZM1593.21 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 841.63c-.88-.873-2.31-.873-3.16 0-.86.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 841.63a2.234 2.234 0 0 0-3.16 0c-.86.873-.86 2.302 0 3.162.87.873 2.29.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1531.64 851.963c-.88-.873-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1543.95 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1556.27 851.963c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 851.963c-.88-.873-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1593.21 851.963c-.87-.873-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 851.963a2.258 2.258 0 0 0-3.17 0c-.87.873-.85 2.302 0 3.162.88.873 2.31.86 3.17 0a2.25 2.25 0 0 0 0-3.162ZM1617.84 851.963c-.87-.873-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 862.309c-.88-.872-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1520.78 862.309c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 862.309c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.873 3.16 0 .87-.873.87-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .87-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 862.309c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 862.309c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 862.309a2.259 2.259 0 0 0-3.17 0c-.87.873-.85 2.302 0 3.162.88.873 2.31.873 3.17 0a2.25 2.25 0 0 0 0-3.162ZM1617.84 862.309c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 873.414c-.88-.873-2.3-.86-3.16 0-.86.86-.88 2.302 0 3.162.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 873.414c-.88-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.87-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 873.414c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.85.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 873.414c-.87-.873-2.3-.86-3.16 0-.86.86-.87 2.302 0 3.162.87.86 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 873.414c-.88-.873-2.31-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.3.873 3.16 0 .86-.873.86-2.302 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 873.414c-.87-.873-2.3-.86-3.16 0a2.26 2.26 0 0 0 0 3.162c.87.873 2.29.873 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.64 883.747c-.88-.872-2.3-.86-3.16 0a2.224 2.224 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 883.747c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 883.747c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.86.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 883.747c-.87-.872-2.3-.86-3.16 0-.87.873-.87 2.302 0 3.162.87.86 2.3.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1520.78 883.747c-.88-.872-2.3-.86-3.16 0-.88.873-.86 2.302 0 3.162.87.873 2.3.86 3.16 0 .87-.872.87-2.301 0-3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 883.747a2.259 2.259 0 0 0-3.17 0c-.87.873-.85 2.302 0 3.162.88.873 2.31.86 3.17 0a2.25 2.25 0 0 0 0-3.162Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 883.747c-.87-.872-2.3-.86-3.16 0a2.25 2.25 0 0 0 0 3.162c.87.873 2.29.86 3.16 0a2.25 2.25 0 0 0 0-3.162ZM1593.21 1034.36c-.87.87-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1593.21 1024.01c-.87.88-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 1013.67c-.87.87-2.3.86-3.16 0-.87-.88-.87-2.3 0-3.16.87-.88 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 1077.84c-.88.88-2.31.86-3.17 0-.87-.87-.85-2.3 0-3.16.88-.87 2.31-.87 3.17 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16a2.24 2.24 0 0 1 3.16 0c.87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 1003.33c-.87.88-2.3.88-3.16 0-.86-.87-.87-2.3 0-3.16.87-.859 2.3-.859 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 1067.5c-.88.87-2.31.86-3.17 0a2.27 2.27 0 0 1 0-3.17 2.26 2.26 0 0 1 3.17 0c.87.88.86 2.31 0 3.17Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 1067.5c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.29-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 992.987c-.87.873-2.3.861-3.16 0-.87-.872-.87-2.301 0-3.162.87-.86 2.3-.86 3.16 0 .86.861.86 2.302 0 3.162Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 1057.15c-.88.87-2.31.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 1057.15c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.29-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1593.21 982.641c-.87.873-2.3.861-3.16 0-.87-.872-.87-2.301 0-3.161.87-.861 2.3-.861 3.16 0a2.25 2.25 0 0 1 0 3.161Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 1046.8c-.88.88-2.31.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .86.86.86 2.3 0 3.16ZM1617.84 1046.8c-.87.88-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.29-.86 3.16 0 .87.86.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 972.295c-.87.873-2.3.873-3.16 0-.87-.872-.87-2.302 0-3.162.87-.872 2.3-.86 3.16 0a2.25 2.25 0 0 1 0 3.162Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.53 1036.46c-.88.87-2.31.86-3.17 0-.87-.87-.85-2.3 0-3.16.88-.88 2.31-.86 3.17 0 .87.87.86 2.3 0 3.16ZM1617.84 1036.46c-.87.87-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.88 2.29-.86 3.16 0 .87.87.86 2.3 0 3.16ZM1605.53 1025.37c-.88.87-2.31.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.84 1025.37c-.87.87-2.3.87-3.16 0-.86-.88-.86-2.31 0-3.17.87-.87 2.29-.86 3.16 0 .87.88.86 2.31 0 3.17ZM1617.84 1015.02c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.87 2.29-.86 3.16 0 .87.86.86 2.3 0 3.16ZM1593.21 1078.56c-.87.88-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 1068.22c-.87.87-2.3.86-3.16 0-.86-.86-.87-2.3 0-3.16.87-.86 2.3-.88 3.16 0 .86.87.86 2.3 0 3.16ZM1593.21 1057.13c-.87.87-2.3.86-3.16 0-.87-.88-.87-2.31 0-3.17.87-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.21 1046.78c-.87.87-2.3.86-3.16 0-.87-.87-.87-2.3 0-3.16.87-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 1077.84c-.88.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.86-.86 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16ZM1580.9 1067.5c-.88.87-2.3.86-3.16 0-.88-.88-.86-2.31 0-3.17.86-.86 2.3-.86 3.16 0 .87.88.86 2.31 0 3.17Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.9 1057.15c-.88.87-2.31.86-3.16 0-.86-.86-.86-2.3 0-3.16.85-.86 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 1078.56c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.87 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.27 1077.84c-.88.88-2.3.86-3.16 0-.88-.87-.86-2.3 0-3.16.87-.87 2.3-.87 3.16 0 .87.87.87 2.3 0 3.16Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 1078.56c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.87-.87 2.3-.86 3.16 0 .87.87.86 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.79 1077.84c-.87.88-2.3.86-3.16 0-.87-.87-.86-2.3 0-3.16.86-.86 2.3-.87 3.16 0 .87.87.86 2.3 0 3.16Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.48 1078.56c-.88.88-2.31.86-3.17 0-.87-.87-.86-2.3 0-3.16a2.26 2.26 0 0 1 3.17 0c.87.87.85 2.3 0 3.16Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.58 1068.22c-.87.87-2.3.86-3.16 0-.86-.86-.86-2.3 0-3.16.87-.88 2.3-.88 3.16 0 .86.87.87 2.3 0 3.16ZM1568.58 1057.13c-.87.87-2.3.86-3.16 0a2.26 2.26 0 0 1 0-3.17c.87-.87 2.3-.86 3.16 0 .87.88.87 2.31 0 3.17Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeMiterlimit: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1977.4 1682.48c-156.92 35.47-340.24-24.24-419.14-164.48-33.09-58.79-46.38-126.65-53.31-193.76-17.5-169.61 2.45-343.124-34.01-509.697-13.88-63.417-47.31-135.194-111.52-144.617-57.55-8.448-107.62 38.602-141.92 85.602-47.91 65.655-84.97 138.785-114.38 214.546-33.4 86.046-57.94 177.276-111.272 252.596-53.33 75.31-145.793 132.71-235.638 111.7-87.279-20.4-141.785-103.75-203.473-168.78-18.523-19.53-40.131-38.73-66.758-42.64-40.788-5.98-76.721 25.07-106.231 53.87",
    stroke: "#5C5C5C",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.89 1677.12c-155.68 34.2-336.81-24.7-416.54-162.29-33.43-57.67-47.64-124.26-55.58-190.26-10.48-87.16-10.87-175.57-14.03-263.7-2.89-80.538-8.11-160.802-25.77-239.523-14.09-62.759-47.18-133.144-109.99-144.098-44.47-7.74-84.67 16.595-117.14 48.973-9.18 9.132-17.74 18.871-25.58 28.686-19.46 24.372-37.44 50.25-53.85 77.519-18.43 30.633-34.74 62.949-49.38 95.947a1137.436 1137.436 0 0 0-16.18 38.311c-34.73 86.425-60.48 178.185-114.673 254.085-52.66 74.1-143.289 130.8-231.516 111.53-85.724-18.71-139.901-98.44-201.096-160.77-18.384-18.72-39.752-37.13-65.987-40.8-40.181-5.62-75.685 24.48-104.98 52.34",
    stroke: "#606060",
    strokeWidth: 0.73
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1982.37 1671.74c-154.43 32.94-333.4-25.17-413.92-160.08-33.77-56.58-48.91-121.89-57.86-186.77-11.82-85.69-13.68-172.84-17.93-259.89-3.87-79.546-9.75-158.962-27.68-236.873-14.3-62.114-47.03-131.134-108.44-143.567-44.06-8.917-84.12 12.61-117.21 42.788-9.35 8.499-18.17 17.644-26.31 26.927a628.316 628.316 0 0 0-56.25 74.813c-19.32 30.165-36.24 62.594-51.41 95.707a1180.637 1180.637 0 0 0-16.78 38.462c-36.04 86.813-63.19 178.973-118.087 255.563-52.142 72.78-140.798 128.9-227.407 111.35-84.168-17.01-138.005-93.12-198.706-152.75-18.245-17.89-39.372-35.54-65.216-38.98-39.562-5.26-74.635 23.91-103.728 50.8",
    stroke: "#646464",
    strokeWidth: 0.72
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1984.86 1666.38c-153.19 31.66-329.97-25.62-411.32-157.87-34.12-55.46-50.17-119.51-60.13-183.29-13.16-84.23-16.5-170.11-21.82-256.09-4.86-78.553-11.4-157.122-29.59-234.211-14.5-61.457-46.92-129.161-106.91-143.048-43.69-10.106-83.57 8.625-117.27 36.603-9.55 7.867-18.61 16.417-27.05 25.169-20.89 21.742-40.66 45.684-58.65 72.106-20.21 29.685-37.74 62.228-53.43 95.466a1178 1178 0 0 0-17.38 38.627c-37.37 87.198-65.81 179.818-121.488 257.058-51.548 71.5-138.295 126.98-223.285 111.17-82.626-15.3-136.109-87.81-196.317-144.73-18.106-17.08-38.993-33.94-64.445-37.14-38.955-4.9-73.585 23.31-102.476 49.26",
    stroke: "#686868",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1987.34 1661.01c-151.95 30.39-326.56-26.08-408.72-155.68-34.46-54.34-51.43-117.13-62.39-179.8-14.5-82.77-19.31-167.36-25.72-252.27-5.83-77.574-13.05-155.282-31.51-231.562-14.7-60.811-46.83-127.226-105.38-142.517-43.3-11.32-82.96 4.718-117.33 30.418-9.73 7.26-19.04 15.19-27.78 23.412-21.61 20.426-42.27 43.407-61.06 69.399-21.1 29.204-39.24 61.861-55.46 95.226a1157.23 1157.23 0 0 0-17.98 38.779c-38.71 87.585-68.43 180.665-124.909 258.535-50.941 70.25-135.805 125.08-219.177 111-81.07-13.61-134.224-82.5-193.94-136.71-17.966-16.28-38.613-32.37-63.66-35.32-38.335-4.54-72.536 22.73-101.224 47.74",
    stroke: "#6C6C6C",
    strokeWidth: 0.68
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1989.83 1655.64c-150.71 29.12-323.13-26.53-406.1-153.47-34.81-53.23-52.7-114.75-64.67-176.31-15.84-81.3-22.11-164.62-29.61-248.47-6.82-76.57-14.69-153.43-33.42-228.9-14.92-60.166-46.73-125.316-103.85-141.998-42.95-12.547-82.39.758-117.41 24.233-9.9 6.64-19.48 13.976-28.51 21.653-22.32 19.111-43.87 41.119-63.47 66.693-21.99 28.723-40.74 61.507-57.49 94.986A1167.947 1167.947 0 0 0 1066.72 953c-40.03 87.97-71.04 181.52-128.303 260.03-50.322 68.98-133.301 123.16-215.055 110.82-79.528-11.91-132.327-77.19-191.55-128.69-17.815-15.46-38.247-30.78-62.889-33.49-37.729-4.18-71.5 22.14-99.973 46.2",
    stroke: "#707070",
    strokeWidth: 0.67
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1992.32 1650.27c-149.47 27.85-319.72-26.99-403.49-151.27-35.15-52.12-53.97-112.38-66.95-172.82-17.18-79.84-24.92-161.9-33.49-244.66-7.8-75.59-16.35-151.59-35.33-226.251-15.12-59.508-46.65-123.456-102.31-141.467-42.61-13.786-81.83-3.2-117.47 18.036-10.09 6.02-19.93 12.749-29.25 19.895-23.03 17.809-45.49 38.842-65.87 63.986-22.87 28.243-42.24 61.14-59.53 94.746a1168.495 1168.495 0 0 0-19.16 39.095c-41.35 88.36-73.652 182.37-131.724 261.52-49.702 67.73-130.811 121.26-210.946 110.63-77.973-10.22-130.431-71.88-189.16-120.67-17.676-14.65-37.868-29.18-62.118-31.66-37.122-3.82-70.45 21.57-98.721 44.66",
    stroke: "#747474",
    strokeWidth: 0.65
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1994.8 1644.9c-148.22 26.58-316.29-27.44-400.89-149.06-35.5-51.01-55.21-110-69.22-169.33-18.53-78.38-27.74-159.15-37.39-240.86-8.77-74.6-17.99-149.75-37.24-223.589-15.33-58.863-46.57-121.635-100.78-140.948-42.27-15.064-81.27-7.172-117.53 11.851a288.87 288.87 0 0 0-29.98 18.137c-23.78 16.442-47.1 36.565-68.28 61.279-23.75 27.762-43.74 60.774-61.54 94.493a1168.281 1168.281 0 0 0-19.78 39.259c-42.67 88.738-76.253 183.228-135.121 262.998-49.07 66.48-128.307 119.35-206.824 110.46-76.417-8.51-128.547-66.57-186.771-112.66-17.536-13.82-37.488-27.58-61.346-29.83-36.502-3.46-69.401 20.98-97.47 43.13",
    stroke: "#787878",
    strokeWidth: 0.63
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1997.29 1639.53c-146.98 25.31-312.88-27.9-398.27-146.87-35.85-49.89-56.48-107.62-71.5-165.84-19.86-76.91-30.55-156.41-41.28-237.05-9.76-73.61-19.64-147.9-39.15-220.929-15.54-58.206-46.5-119.852-99.25-140.43-41.94-16.354-80.72-11.143-117.6 5.666a278.465 278.465 0 0 0-30.71 16.379c-24.5 15.114-48.7 34.288-70.68 58.573-24.64 27.281-45.23 60.419-63.58 94.252a1189.77 1189.77 0 0 0-20.37 39.411c-44 89.128-78.845 184.088-138.535 264.498-48.425 65.23-125.816 117.43-202.702 110.27-74.875-6.81-126.65-61.25-184.394-104.63-17.397-13.02-37.109-26-60.575-28.01-35.895-3.08-68.364 20.4-96.218 41.6",
    stroke: "#7C7C7C",
    strokeWidth: 0.62
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1999.77 1634.17c-145.74 24.04-309.45-28.36-395.67-144.66-36.19-48.78-57.74-105.24-73.77-162.35-21.21-75.44-33.36-153.68-45.18-233.24-10.75-72.61-21.29-146.055-41.05-218.275-15.76-57.561-46.42-118.106-97.73-139.899-41.61-17.682-80.17-15.101-117.66-.518-10.66 4.148-21.25 9.043-31.44 14.621-25.21 13.799-50.32 31.999-73.08 55.878-25.54 26.814-46.74 60.053-65.61 94.012a1199.472 1199.472 0 0 0-20.97 39.576c-45.319 89.505-81.442 184.965-141.941 265.975-47.793 64-123.313 115.52-198.593 110.1-73.32-5.12-124.754-55.94-182.004-96.62-17.259-12.19-36.73-24.4-59.792-26.18-35.275-2.73-67.314 19.82-94.966 40.07",
    stroke: "gray",
    strokeWidth: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2002.26 1628.79c-144.5 22.77-306.04-28.81-393.05-142.45-36.54-47.67-59.01-102.87-76.04-158.87-22.53-73.98-36.16-150.96-49.07-229.44-11.73-71.62-22.93-144.221-42.96-215.618-15.96-56.903-46.34-116.412-96.18-139.38-41.3-19.023-79.62-19.074-117.73-6.704a258.329 258.329 0 0 0-32.17 12.863c-25.94 12.471-51.93 29.723-75.49 53.172-26.42 26.333-48.23 59.686-67.64 93.772a1184.496 1184.496 0 0 0-21.57 39.727c-46.641 89.898-84.028 185.828-145.349 267.468-47.136 62.76-120.823 113.61-194.471 109.92-71.765-3.41-122.871-50.63-179.615-88.6-17.107-11.38-36.35-22.8-59.02-24.35-34.669-2.36-66.265 19.24-93.715 38.54",
    stroke: "#848484",
    strokeWidth: 0.58
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2004.75 1623.43c-143.25 21.5-302.61-29.27-390.45-140.25-36.88-46.56-60.27-100.49-78.31-155.38-23.87-72.53-38.98-148.21-52.96-225.63-12.71-70.64-24.6-142.378-44.88-212.967-16.15-56.257-46.25-114.742-94.65-138.849-40.96-20.401-79.07-23.044-117.78-12.888-11.04 2.897-22.13 6.59-32.91 11.105-26.64 11.156-53.54 27.446-77.89 50.465-27.31 25.853-49.74 59.332-69.66 93.532-7.67 13.141-15.04 26.459-22.17 39.891-47.969 90.281-86.608 186.701-148.751 268.941-46.49 61.52-118.318 111.7-190.361 109.75-70.223-1.72-120.974-45.32-177.238-80.58-16.968-10.56-35.971-21.21-58.249-22.51-34.049-2.01-65.216 18.65-92.463 36.99",
    stroke: "#888",
    strokeWidth: 0.57
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2007.23 1618.05c-142.01 20.23-299.2-29.72-387.84-138.05-37.23-45.44-61.54-98.11-80.59-151.89-25.21-71.05-41.79-145.47-56.85-221.8-13.69-69.64-26.23-140.536-46.79-210.315-16.38-55.613-46.16-113.123-93.12-138.33-40.64-21.805-78.53-27.029-117.85-19.086-11.23 2.264-22.56 5.363-33.65 9.347-27.36 9.84-55.15 25.157-80.28 47.759-28.2 25.371-51.25 58.964-71.69 93.291-7.87 13.192-15.44 26.548-22.77 40.043-49.302 90.661-89.192 187.581-152.17 270.441-45.82 60.29-115.828 109.78-186.24 109.57-68.667-.03-119.077-40.01-174.848-72.57-16.828-9.75-35.604-19.61-57.478-20.69-33.442-1.64-64.178 18.08-91.21 35.47",
    stroke: "#8C8C8C",
    strokeWidth: 0.55
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2009.72 1612.69c-140.77 18.96-295.77-30.19-385.22-135.85-37.58-44.33-62.81-95.73-82.87-148.4-26.55-69.59-44.59-142.74-60.74-218-14.68-68.65-27.89-138.683-48.7-207.652-16.58-54.956-46.05-111.542-91.59-137.812-40.3-23.234-77.99-31.013-117.92-25.271-11.41 1.644-23 4.136-34.38 7.589-28.06 8.525-56.75 22.88-82.7 45.052-29.08 24.891-52.73 58.598-73.72 93.051-8.07 13.242-15.83 26.649-23.37 40.207-50.61 91.056-91.752 188.456-155.564 271.916-45.163 59.07-113.324 107.88-182.131 109.38-67.124 1.68-117.193-34.69-172.458-64.54-16.69-8.93-35.225-18.04-56.706-18.86-32.836-1.29-63.13 17.49-89.96 33.94",
    stroke: "#909090",
    strokeWidth: 0.53
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2012.2 1607.32c-139.54 17.68-292.35-30.65-382.62-133.66-37.92-43.23-64.07-93.35-85.14-144.9-27.9-68.12-47.4-140-64.64-214.2-15.65-67.66-29.53-136.846-50.61-204.993-16.79-54.31-45.92-109.987-90.05-137.281-39.94-24.701-77.45-34.997-117.99-31.455-11.6 1.011-23.43 2.909-35.11 5.83-28.78 7.21-58.36 20.604-85.1 42.346-29.98 24.41-54.24 58.243-75.75 92.81-8.27 13.28-16.23 26.751-23.96 40.36-51.94 91.433-94.321 189.343-158.98 273.413-44.493 57.85-110.834 105.96-178.009 109.2-65.57 3.38-115.297-29.39-170.082-56.52-16.55-8.12-34.846-16.45-55.935-17.04-32.216-.92-62.08 16.91-88.707 32.4",
    stroke: "#949494",
    strokeWidth: 0.52
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2014.69 1601.94c-138.3 16.42-288.93-31.1-380.02-131.44-38.26-42.12-65.33-90.97-87.41-141.41-29.24-66.67-50.22-137.27-68.53-210.39-16.64-66.68-31.18-135.004-52.52-202.341-17-53.653-45.79-108.469-88.52-136.763-39.58-26.193-76.91-38.98-118.06-37.64-11.79.38-23.87 1.682-35.84 4.073-29.48 5.894-59.98 18.314-87.51 39.638-30.86 23.93-55.74 57.877-77.78 92.571-8.47 13.331-16.64 26.851-24.566 40.524-53.267 91.828-96.875 190.238-162.381 274.888-43.81 56.64-108.33 104.06-173.9 109.03-64.014 5.07-113.35-24.19-167.692-48.51-16.386-7.33-34.466-14.85-55.151-15.2-31.609-.57-61.03 16.33-87.468 30.87",
    stroke: "#989898",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2017.17 1596.58c-137.05 15.15-285.51-31.56-377.4-129.24-38.6-41-66.58-88.6-89.69-137.94-30.58-65.2-53.03-134.53-72.43-206.58-17.62-65.68-32.83-133.154-54.43-199.682-17.21-53.007-45.62-106.989-86.99-136.231-39.18-27.711-76.36-42.965-118.11-43.825-12-.24-24.3.455-36.58 2.315-30.21 4.578-61.59 16.037-89.91 36.932-31.75 23.462-57.24 57.51-79.8 92.33-8.68 13.381-17.048 26.952-25.165 40.675-54.595 92.206-99.429 191.126-165.795 276.386-43.14 55.42-105.84 102.14-169.778 108.84-62.472 6.78-111.466-18.88-165.302-40.48-16.247-6.53-34.088-13.26-54.381-13.37-30.989-.2-59.993 15.75-86.216 29.33",
    stroke: "#9C9C9C",
    strokeWidth: 0.48
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2019.66 1591.2c-135.81 13.88-282.09-32.01-374.8-127.03-38.95-39.9-67.84-86.23-91.95-134.45-31.92-63.73-55.84-131.79-76.31-202.77-18.61-64.7-34.48-131.314-56.34-197.033-17.41-52.362-45.44-105.522-85.45-135.712-38.78-29.255-75.83-46.962-118.18-50.023-12.19-.872-24.75-.771-37.32.557-30.91 3.263-63.19 13.761-92.31 34.225-32.63 22.981-58.74 57.156-81.84 92.09-8.873 13.432-17.446 27.054-25.765 40.827-55.91 92.599-101.971 192.019-169.197 277.859-42.457 54.21-103.336 100.24-165.668 108.67-60.917 8.48-109.582-13.57-162.926-32.46-16.108-5.71-33.707-11.66-53.608-11.55-30.383.16-58.945 15.16-84.965 27.8",
    stroke: "#A0A0A0",
    strokeWidth: 0.47
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2022.15 1585.84c-134.57 12.61-278.67-32.47-372.18-124.84-39.29-38.77-69.11-83.84-94.23-130.95-33.25-62.27-58.64-129.06-80.2-198.97-19.58-63.71-36.13-129.47-58.25-194.371-17.62-51.705-45.22-104.092-83.91-135.181-38.35-30.823-75.28-50.958-118.25-56.207-12.37-1.505-25.17-1.999-38.04-1.202-31.62 1.948-64.81 11.472-94.71 31.531-33.52 22.501-60.24 56.79-83.868 91.85-9.078 13.47-17.84 27.155-26.362 40.992-57.238 92.978-104.512 192.928-172.61 279.358-41.762 53-100.845 98.32-161.547 108.49-59.362 10.17-107.686-8.26-160.536-24.45-15.969-4.89-33.341-10.07-52.837-9.71-29.763.52-57.895 14.58-83.714 26.27",
    stroke: "#A4A4A4",
    strokeWidth: 0.45
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2024.63 1580.46c-133.33 11.34-275.25-32.92-369.58-122.63-39.63-37.67-70.37-81.47-96.5-127.47-34.6-60.81-61.46-126.32-84.1-195.15-20.57-62.71-37.78-127.63-60.17-191.722-17.82-51.059-45-102.675-82.38-134.662-37.9-32.417-74.74-54.955-118.31-62.392-12.57-2.138-25.61-3.226-38.78-2.96-32.33.645-66.41 9.195-97.11 28.825-34.42 22.02-61.74 56.422-85.902 91.609-9.281 13.52-18.245 27.256-26.956 41.143-58.565 93.367-107.041 193.839-176.011 280.839-41.067 51.79-98.342 96.41-157.438 108.3-57.819 11.88-105.802-2.95-158.146-16.43-15.83-4.07-32.962-8.47-52.066-7.89-29.156.88-56.846 14-82.462 24.74",
    stroke: "#A8A8A8",
    strokeWidth: 0.43
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2027.12 1575.1c-132.08 10.07-271.83-33.38-366.97-120.42-39.99-36.55-71.64-79.09-98.78-123.98-35.92-59.34-64.27-123.58-87.99-191.35-21.56-61.72-39.44-125.78-62.08-189.057-18.03-50.402-44.75-101.284-80.86-134.144-37.41-34.035-74.18-58.964-118.37-68.577-12.75-2.77-26.04-4.414-39.51-4.718-33.05-.607-68.02 6.919-99.53 26.118-35.3 21.54-63.24 56.069-87.921 91.369-9.482 13.571-18.649 27.358-27.563 41.308-59.88 93.747-109.556 194.761-179.425 282.331-40.371 50.6-95.851 94.5-153.316 108.12-56.264 13.57-103.917 2.37-155.756-8.41-15.691-3.26-32.582-6.88-51.282-6.06-28.549 1.24-55.809 13.42-81.21 23.21",
    stroke: "#ACACAC",
    strokeWidth: 0.42
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2029.6 1569.73c-130.84 8.79-268.41-33.84-364.35-118.23-40.34-35.43-72.91-76.7-101.06-120.48-37.27-57.88-67.08-120.85-91.89-187.54-22.53-60.74-41.07-123.95-63.98-186.408-18.25-49.757-44.46-99.893-79.32-133.613-36.88-35.679-73.63-62.961-118.43-74.762a207.544 207.544 0 0 0-40.24-6.475c-33.76-1.923-69.65 4.629-101.94 23.411-36.18 21.059-64.73 55.702-89.944 91.128-9.685 13.61-19.053 27.459-28.157 41.46-61.207 94.139-112.072 195.689-182.826 283.809-39.663 49.4-93.347 92.59-149.194 107.95-54.709 15.26-102.034 7.68-153.38-.39-15.551-2.44-32.203-5.29-50.511-4.23-27.929 1.61-54.759 12.83-79.958 21.67",
    stroke: "#B0B0B0",
    strokeWidth: 0.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2032.09 1564.36c-129.6 7.53-264.99-34.29-361.75-116.02-40.67-34.32-74.17-74.33-103.33-116.99-38.61-56.42-69.89-118.12-95.77-183.72-23.51-59.75-42.72-122.11-65.9-183.753-18.44-49.1-44.13-98.528-77.78-133.094-36.34-37.337-73.08-66.971-118.49-80.947a207.723 207.723 0 0 0-40.98-8.234c-34.48-3.238-71.25 2.353-104.34 20.705-37.07 20.578-66.237 55.334-91.979 90.888-9.888 13.659-19.459 27.559-28.764 41.624-62.536 94.518-114.577 196.621-186.24 285.301-38.968 48.21-90.857 90.68-145.085 107.77-53.167 16.97-100.15 13-150.99 7.63-15.413-1.63-31.824-3.71-49.74-2.41-27.323 1.97-53.71 12.25-78.706 20.14",
    stroke: "#B4B4B4",
    strokeWidth: 0.38
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2034.58 1558.99c-128.36 6.26-261.57-34.76-359.14-113.82-41.02-33.21-75.44-71.96-105.6-113.52-39.94-54.95-72.7-115.37-99.66-179.91-24.5-58.75-44.38-120.26-67.81-181.096-18.66-48.455-43.81-97.162-76.25-132.563-35.74-39.006-72.52-70.968-118.57-87.144a208.66 208.66 0 0 0-41.71-9.992c-35.2-4.554-72.86.076-106.74 17.998-37.96 20.097-67.744 54.98-94.005 90.647-10.09 13.711-19.851 27.661-29.359 41.776-63.862 94.91-117.066 197.574-189.641 286.794-38.259 47.02-88.353 88.77-140.963 107.59-51.611 18.67-98.266 18.32-148.6 15.65-15.273-.81-31.444-2.11-48.968-.57-26.704 2.33-52.674 11.66-77.455 18.61",
    stroke: "#B8B8B8",
    strokeWidth: 0.37
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2037.06 1553.62c-127.12 4.99-258.15-35.21-356.53-111.61-41.37-32.1-76.68-69.58-107.87-110.03-41.28-53.49-75.51-112.64-103.55-176.11-25.48-57.76-46.03-118.41-69.72-178.435-18.87-47.809-43.43-95.795-74.72-132.044-35.13-40.688-71.97-74.977-118.64-93.329-13.5-5.312-27.8-9.322-42.44-11.75-35.91-5.869-74.47-2.213-109.14 15.291-38.86 19.63-69.239 54.614-96.044 90.408-10.304 13.761-20.255 27.762-29.952 41.94-65.178 95.29-119.545 198.519-193.055 288.269-37.539 45.84-85.863 86.87-136.854 107.42-50.069 20.36-96.369 23.73-146.223 23.67-15.134.03-31.066-.52-48.198 1.25-26.096 2.68-51.623 11.08-76.202 17.07",
    stroke: "#BCBCBC",
    strokeWidth: 0.35
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2039.55 1548.25c-125.87 3.72-254.73-35.67-353.92-109.42-41.71-30.99-77.95-67.2-110.15-106.53-42.63-52.02-78.32-109.91-107.45-172.3-26.46-56.78-47.68-116.58-71.63-175.785-19.07-47.152-43.03-94.443-73.18-131.526-34.45-42.383-71.37-79.075-118.69-99.514a210.621 210.621 0 0 0-43.18-13.508c-36.63-7.171-76.08-4.49-111.54 12.585-39.74 19.149-70.744 54.247-98.067 90.167-10.507 13.799-20.66 27.863-30.559 42.092-66.506 95.682-122.024 199.479-196.456 289.769-36.819 44.65-83.36 84.94-132.733 107.24-48.513 22.05-94.485 29.04-143.833 31.68-14.995.85-30.699 1.07-47.414 3.09-25.476 3.04-50.574 10.49-74.951 15.53",
    stroke: "silver",
    strokeWidth: 0.33
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.02 1542.89c-124.62 2.44-251.3-36.13-351.3-107.21-42.05-29.87-79.21-64.82-112.42-103.04-43.97-50.57-81.13-107.17-111.34-168.5-27.45-55.77-49.33-114.73-73.55-173.121-19.28-46.506-42.62-93.076-71.65-130.994-33.76-44.091-70.82-83.059-118.76-105.699a213.323 213.323 0 0 0-43.92-15.266c-37.33-8.487-77.68-6.767-113.94 9.891-40.62 18.668-72.232 53.892-100.098 89.926-10.709 13.85-21.064 27.952-31.154 42.257-67.833 96.061-124.476 200.456-199.87 291.246-36.097 43.47-80.868 83.03-128.623 107.05-46.958 23.77-92.589 34.35-141.444 39.7-14.843 1.67-30.319 2.67-46.642 4.92-24.87 3.4-49.525 9.92-73.699 14",
    stroke: "#C4C4C4",
    strokeWidth: 0.32
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2044.52 1537.51c-123.39 1.18-247.89-36.58-348.7-105-42.41-28.78-80.48-62.45-114.7-99.55-45.31-49.1-83.95-104.44-115.23-164.69-28.43-54.79-50.97-112.89-75.45-170.471-19.49-45.849-42.17-91.711-70.12-130.477-33.03-45.798-70.28-87.043-118.83-111.883a216.23 216.23 0 0 0-44.64-17.024c-38.06-9.802-79.3-9.056-116.35 7.184-41.508 18.188-73.736 53.526-102.121 89.686-10.911 13.9-21.456 28.053-31.748 42.409-69.16 96.453-126.916 201.446-203.271 292.736-35.376 42.29-78.365 81.12-124.501 106.88-45.416 25.46-90.692 39.66-139.067 47.72-14.704 2.47-29.94 4.26-45.871 6.74-24.25 3.77-48.488 9.33-72.447 12.47",
    stroke: "#C8C8C8",
    strokeWidth: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2047.01 1532.15c-122.15-.1-244.47-37.03-346.1-102.8-42.74-27.66-81.74-60.07-116.98-96.06-46.64-47.64-86.74-101.71-119.11-160.89-29.41-53.8-52.62-111.03-77.37-167.81-19.7-45.203-41.69-90.331-68.59-129.944-32.25-47.518-69.71-91.04-118.89-118.081a219.677 219.677 0 0 0-45.37-18.782c-38.77-11.118-80.91-11.333-118.76 4.477-42.398 17.707-75.246 53.159-104.162 89.446-11.114 13.951-21.861 28.154-32.355 42.573-70.475 96.833-129.356 202.441-206.685 294.221-34.656 41.13-75.874 79.21-120.392 106.69-43.86 27.16-88.808 44.98-136.677 55.74-14.565 3.3-29.56 5.86-45.099 8.58-23.644 4.13-47.439 8.75-71.196 10.94",
    stroke: "#CCC",
    strokeWidth: 0.28
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2049.48 1526.77c-120.89-1.36-241.05-37.49-343.47-100.6-43.09-26.55-83.01-57.69-119.26-92.58-47.98-46.17-89.55-98.96-123.01-157.08-30.39-52.81-54.26-109.2-79.27-165.15-19.9-44.561-41.21-88.956-67.05-129.429-31.44-49.226-69.16-95.024-118.95-124.266a225.385 225.385 0 0 0-46.11-20.54c-39.49-12.433-82.51-13.609-121.16 1.771-43.296 17.226-76.739 52.805-106.185 89.205-11.316 13.989-22.266 28.256-32.95 42.725-71.802 97.225-131.632 203.564-210.085 295.704-33.86 40.01-73.384 77.31-116.271 106.53-42.305 28.86-86.912 50.28-134.287 63.75-14.426 4.11-29.181 7.45-44.328 10.4-23.037 4.49-46.39 8.17-69.945 9.41",
    stroke: "#D0D0D0",
    strokeWidth: 0.27
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2051.97 1521.41c-236.65-5.21-466.66-138.22-589.29-340.75-56.35-93.07-90.66-198.127-146.7-291.406-30.6-50.933-68.6-99.008-119.01-130.451-50.41-31.442-114.86-44.293-170.41-23.234-44.182 16.746-78.243 52.438-108.209 88.966-88.909 108.367-155.908 233.565-247.042 340.075-91.135 106.51-216.168 196.51-356.309 198.22",
    stroke: "#D4D4D4",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.888 978.403C372.77 900.745 469 857.615 559.793 850.09c90.794-7.539 177.15 16.391 257.019 48.833 66.48 27.004 130.469 60.204 201.928 75.255 71.46 15.039 153.76 9.638 220.61-35.275 62.87-42.231 103.17-113.3 125.69-184.116 22.52-70.828 30.06-143.49 45.05-215.331 20.21-96.933 56.75-197.016 128.61-270.943 71.85-73.928 185.84-113.313 265.61-70.804 44.42 23.665 74.07 69.147 121.62 87.069",
    stroke: "#000"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M314.521 982.185c58.476-77.697 154.049-121.307 244.501-129.629 66.619-6.096 130.988 4.756 192.195 23.601 21.848 6.729 43.279 14.469 64.28 22.804 66.48 26.384 130.52 58.99 201.883 73.421 71.31 14.444 153.15 8.5 219.72-36.388 62.62-42.231 102.99-112.92 125.76-183.433a600.949 600.949 0 0 0 5.48-17.934c18.68-64.796 26.54-130.97 40.6-196.397a922.77 922.77 0 0 1 7.87-33.568c19.18-75.002 49.48-149.777 99.56-210.55a371.95 371.95 0 0 1 22.45-24.891c72.07-72.991 185.48-111.213 265.35-69.248 44.4 23.361 74.3 68.072 121.76 85.576",
    stroke: "#020202"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M315.166 985.979c58.071-77.734 152.987-121.838 243.11-130.944 66.328-6.653 130.533 3.516 191.69 21.78 21.822 6.513 43.253 14.052 64.254 22.197 66.48 25.764 130.57 57.776 201.82 71.587 71.14 13.837 152.53 7.361 218.83-37.501 62.39-42.231 102.81-112.541 125.86-182.737a650.203 650.203 0 0 0 5.55-17.859c18.94-64.492 27.16-130.375 41.56-195.487a872.345 872.345 0 0 1 8.05-33.39c19.57-74.635 50.26-148.967 100.54-209.07 7.12-8.5 14.63-16.708 22.55-24.6 72.28-72.056 185.12-109.127 265.08-67.68 44.35 23.045 74.51 67.009 121.91 84.084",
    stroke: "#050505"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M315.798 989.761c57.667-77.76 151.925-122.369 241.707-132.26 66.025-7.196 130.09 2.29 191.183 19.959 21.811 6.298 43.229 13.647 64.23 21.59 66.48 25.144 130.608 56.561 201.762 69.753 70.99 13.243 151.93 6.236 217.94-38.627 62.13-42.218 102.63-112.174 125.93-182.054a646.303 646.303 0 0 0 5.62-17.77c19.18-64.188 27.77-129.793 42.52-194.589a886.808 886.808 0 0 1 8.21-33.226c19.97-74.256 51.03-148.145 101.54-207.59a373.662 373.662 0 0 1 22.65-24.31c72.5-71.119 184.77-107.026 264.82-66.11 44.33 22.741 74.72 65.933 122.06 82.578",
    stroke: "#070707"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M316.442 993.555c57.251-77.797 150.864-122.887 240.304-133.575 65.722-7.74 129.647 1.05 190.665 18.15 21.798 6.096 43.204 13.242 64.204 20.983 66.48 24.524 130.659 55.347 201.705 67.932 70.83 12.635 151.32 5.097 217.05-39.74 61.89-42.219 102.44-111.795 126.02-181.359 2-5.881 3.88-11.787 5.68-17.694 19.43-63.885 28.39-129.211 43.48-193.678a902.414 902.414 0 0 1 8.39-33.061c20.36-73.89 51.82-147.336 102.54-206.111a370.045 370.045 0 0 1 22.75-24.019c72.7-70.183 184.42-104.927 264.55-64.542 44.31 22.425 74.95 64.871 122.2 81.086",
    stroke: "#090909"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M317.075 997.337c56.845-77.823 149.801-123.419 238.9-134.89 65.431-8.298 129.192-.178 190.16 16.328 21.772 5.881 43.177 12.825 64.178 20.376 66.48 23.904 130.71 54.133 201.657 66.098 70.66 12.041 150.71 3.971 216.16-40.853 61.64-42.219 102.26-111.416 126.1-180.663a639.303 639.303 0 0 0 5.75-17.606c19.69-63.581 29.02-128.617 44.44-192.767a884.618 884.618 0 0 1 8.57-32.885c20.75-73.522 52.59-146.526 103.54-204.63a365.597 365.597 0 0 1 22.84-23.728c72.91-69.247 184.06-102.828 264.29-62.974 44.26 22.121 75.16 63.796 122.35 79.581",
    stroke: "#0C0C0C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M317.719 1001.13c56.441-77.86 148.752-123.949 237.51-136.204 65.127-8.841 128.75-1.417 189.654 14.507 21.759 5.666 43.152 12.42 64.153 19.768 66.48 23.285 130.76 52.919 201.594 64.265 70.5 11.433 150.09 2.833 215.27-41.966 61.38-42.219 102.07-111.049 126.17-179.98a604.046 604.046 0 0 0 5.81-17.53c19.93-63.278 29.64-128.035 45.4-191.869 2.7-10.89 5.61-21.818 8.75-32.721 21.14-73.155 53.37-145.704 104.54-203.138a362.648 362.648 0 0 1 22.94-23.437c73.13-68.311 183.69-100.728 264.02-61.418 44.24 21.805 75.39 62.734 122.5 78.088",
    stroke: "#0E0E0E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M318.352 1004.91c56.036-77.896 147.689-124.465 236.106-137.518 64.836-9.385 128.307-2.643 189.148 12.686 21.734 5.464 43.127 12.003 64.128 19.161 66.48 22.666 130.81 51.705 201.536 62.443 70.35 10.84 149.49 1.708 214.39-43.079 61.14-42.206 101.89-110.669 126.26-179.284 2.06-5.805 4-11.611 5.88-17.441 20.17-62.975 30.24-127.454 46.36-190.959 2.76-10.839 5.71-21.704 8.91-32.556 21.55-72.776 54.16-144.894 105.53-201.658a364.181 364.181 0 0 1 23.02-23.146c73.35-67.375 183.34-98.628 263.76-59.85 44.2 21.502 75.61 61.659 122.64 76.583",
    stroke: "#101010"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.996 1008.71c55.632-77.927 146.628-125.002 234.703-138.839 64.533-9.941 127.865-3.87 188.642 10.865 21.722 5.248 43.102 11.598 64.103 18.567 66.48 22.045 130.849 50.49 201.476 60.609 70.18 10.232 148.88.569 213.5-44.192 60.89-42.206 101.72-110.29 126.33-178.602 2.08-5.767 4.06-11.56 5.96-17.365 20.43-62.671 30.86-126.872 47.32-190.048a877.4 877.4 0 0 1 9.09-32.391c21.94-72.41 54.93-144.086 106.53-200.179a360.461 360.461 0 0 1 23.12-22.855c73.55-66.44 182.99-96.529 263.49-58.282 44.18 21.186 75.83 60.597 122.8 75.091",
    stroke: "#131313"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M319.629 1012.49c55.214-77.963 145.565-125.532 233.299-140.153 64.242-10.485 127.409-5.109 188.136 9.044 21.709 5.046 43.077 11.193 64.078 17.96 66.48 21.425 130.899 49.289 201.428 58.775 70.02 9.637 148.27-.557 212.6-45.305 60.65-42.206 101.53-109.911 126.41-177.906 2.1-5.742 4.1-11.51 6.02-17.277 20.67-62.367 31.48-126.277 48.28-189.15a878.42 878.42 0 0 1 9.27-32.214c22.33-72.043 55.71-143.263 107.52-198.699a356.904 356.904 0 0 1 23.23-22.564c73.76-65.504 182.71-94.594 263.23-56.713 44.18 20.793 76.05 59.521 122.94 73.585",
    stroke: "#151515"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M320.273 1016.28c54.81-77.984 144.504-126.046 231.909-141.464 63.939-11.029 126.967-6.336 187.618 7.235 21.684 4.832 43.051 10.776 64.052 17.353 66.48 20.793 130.95 48.075 201.358 56.954 69.87 9.03 147.67-1.695 211.72-46.418 60.4-42.194 101.35-109.544 126.5-177.21a578.537 578.537 0 0 0 6.08-17.202c20.93-62.063 32.1-125.695 49.25-188.239a901.96 901.96 0 0 1 9.43-32.05c22.72-71.675 56.49-142.453 108.52-197.219a360.746 360.746 0 0 1 23.31-22.273c73.98-64.567 182.36-92.519 262.95-55.157 44.17 20.477 76.27 58.458 123.09 72.093",
    stroke: "#171717"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M320.906 1020.07c54.405-78.03 143.403-126.762 230.505-142.787 63.622-11.712 126.524-7.576 187.112 5.413 21.671 4.617 43.026 10.371 64.027 16.746 66.48 20.173 131 46.86 201.31 55.12 69.71 8.436 147.05-2.834 210.83-47.531 60.16-42.194 101.16-109.165 126.58-176.527a693.155 693.155 0 0 0 6.15-17.113c21.18-61.76 32.73-125.113 50.21-187.329a897.963 897.963 0 0 1 9.61-31.885c23.11-71.296 57.16-141.745 109.51-195.739a348.52 348.52 0 0 1 23.41-21.983c74.2-63.631 182.01-90.432 262.69-53.589 44.14 20.161 76.48 57.384 123.23 70.601",
    stroke: "#191919"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M321.551 1023.86c54-78.064 142.341-127.302 229.101-144.098 63.319-12.269 126.082-8.803 186.607 3.592 21.658 4.414 43.001 9.966 64.002 16.138 66.479 19.554 131.038 45.647 201.249 53.286 69.54 7.829 146.44-3.959 209.93-48.644 59.91-42.193 100.99-108.785 126.67-175.831a668.626 668.626 0 0 0 6.22-17.025c21.43-61.456 33.34-124.531 51.16-186.43 3.05-10.574 6.3-21.16 9.79-31.708 23.51-70.93 57.93-140.936 110.51-194.26a345.227 345.227 0 0 1 23.51-21.704c74.41-62.696 181.67-88.346 262.42-52.021 44.11 19.832 76.71 56.322 123.38 69.096",
    stroke: "#1C1C1C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M322.183 1027.64c53.596-78.087 141.279-127.831 227.698-145.412 63.015-12.825 125.626-10.043 186.101 1.771 21.633 4.199 42.975 9.549 63.963 15.531 66.468 18.934 131.089 44.432 201.195 51.452 69.38 7.235 145.83-5.097 209.05-49.757 59.67-42.181 100.81-108.418 126.74-175.148a598.434 598.434 0 0 0 6.28-16.949c21.68-61.14 33.97-123.937 52.13-185.519 3.11-10.524 6.41-21.047 9.97-31.544 23.89-70.563 58.7-140.139 111.5-192.78 7.55-7.526 15.43-14.646 23.61-21.413 74.61-61.76 181.31-86.259 262.15-50.453 44.07 19.516 76.92 55.247 123.53 67.604",
    stroke: "#1E1E1E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M322.827 1031.44c53.179-78.131 140.218-128.381 226.308-146.733 62.712-13.369 125.184-11.269 185.595-.051 21.62 3.984 42.95 9.145 63.938 14.925 66.468 18.314 131.152 43.066 201.135 49.63 69.237 6.489 145.227-6.222 208.167-50.87 59.41-42.18 100.61-108.038 126.81-174.453a610.65 610.65 0 0 0 6.36-16.859c21.93-60.837 34.58-123.355 53.09-184.622a877.878 877.878 0 0 1 10.13-31.38c24.29-70.196 59.47-139.329 112.5-191.299 7.59-7.437 15.5-14.457 23.71-21.122 74.82-60.824 180.95-84.172 261.88-48.885 44.05 19.2 77.14 54.184 123.68 66.098",
    stroke: "#202020"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M323.46 1035.22c52.774-78.154 139.142-128.91 224.904-148.047 62.408-13.925 124.741-12.496 185.076-1.872 21.596 3.782 42.925 8.727 63.914 14.318 66.467 17.694 131.202 41.852 201.083 47.796 69.073 5.882 144.603-7.361 207.263-51.983 59.18-42.18 100.44-107.659 126.91-173.769a661.78 661.78 0 0 0 6.42-16.784c22.18-60.533 35.2-122.774 54.05-183.711 3.23-10.41 6.65-20.832 10.31-31.216 24.68-69.816 60.24-138.52 113.5-189.807 7.62-7.348 15.56-14.267 23.8-20.831 75.04-59.875 180.61-82.085 261.63-47.329 44.02 18.884 77.36 53.109 123.81 64.606",
    stroke: "#232323"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M324.104 1039.01c52.37-78.188 138.081-129.45 223.501-149.358 62.118-14.482 124.286-13.735 184.571-3.68 21.583 3.567 42.887 8.322 63.888 13.723 66.467 17.074 131.253 40.625 201.02 45.962 68.906 5.275 143.996-8.486 206.386-53.108 58.91-42.168 100.25-107.28 126.97-173.075a573.447 573.447 0 0 0 6.49-16.695c22.42-60.229 35.82-122.191 55.01-182.8a871.722 871.722 0 0 1 10.48-31.038c25.08-69.45 61.04-137.724 114.49-188.328 7.66-7.247 15.64-14.077 23.9-20.54 75.25-58.94 180.25-79.998 261.35-45.76 44 18.579 77.59 52.046 123.97 63.1",
    stroke: "#252525"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M324.737 1042.79c51.965-78.224 137.018-129.979 222.097-150.671 61.814-15.039 123.844-14.963 184.065-5.502 21.57 3.352 42.862 7.917 63.863 13.116 66.467 16.455 131.291 39.411 200.969 44.141 68.759 4.667 143.389-9.625 205.479-54.222 58.68-42.168 100.08-106.913 127.06-172.378a634.71 634.71 0 0 0 6.56-16.62c22.67-59.926 36.44-121.597 55.98-181.902 3.35-10.296 6.87-20.604 10.64-30.874 25.47-69.083 61.8-136.914 115.49-186.848 7.7-7.158 15.71-13.887 24-20.249 75.45-58.003 179.89-77.911 261.08-44.192 43.97 18.264 77.8 50.971 124.13 61.608",
    stroke: "#272727"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M325.381 1046.59c51.561-78.255 135.944-130.516 220.707-151.992 61.511-15.595 123.401-16.202 183.559-7.323 21.545 3.149 42.837 7.5 63.838 12.508 66.467 15.836 131.341 38.184 200.906 42.308 68.589 4.06 142.789-10.751 204.599-55.335 58.43-42.168 99.88-106.533 127.14-171.696 2.29-5.501 4.5-11.003 6.63-16.53 22.92-59.623 37.04-121.016 56.93-180.992 3.4-10.245 7.01-20.49 10.83-30.709 25.85-68.717 62.58-136.105 116.48-185.368 7.74-7.071 15.79-13.698 24.1-19.959 75.67-57.067 179.54-75.824 260.82-42.623 43.94 17.947 78.03 49.908 124.26 60.115",
    stroke: "#2A2A2A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M326.014 1050.37c51.143-78.291 134.881-131.046 219.303-153.306 61.207-16.139 122.958-17.429 183.053-9.144 21.532 2.934 42.811 7.095 63.812 11.901 66.468 15.216 131.393 36.97 200.856 40.474 68.432 3.453 142.182-11.889 203.712-56.448 58.19-42.168 99.71-106.154 127.22-171a612.244 612.244 0 0 0 6.69-16.455c23.16-59.319 37.67-120.434 57.89-180.081 3.47-10.194 7.12-20.389 11-30.532 26.25-68.337 63.36-135.295 117.49-183.888 7.77-6.982 15.85-13.521 24.19-19.668 75.88-56.132 179.18-73.737 260.55-41.055 43.92 17.631 78.24 48.833 124.42 58.61",
    stroke: "#2C2C2C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M326.646 1054.16c50.738-78.312 133.819-131.585 217.899-154.617 60.904-16.695 122.504-18.668 182.536-10.966 21.519 2.732 42.785 6.678 63.786 11.295 66.468 14.595 131.43 35.755 200.793 38.639 68.26 2.846 141.56-13.027 202.82-57.561 57.93-42.155 99.53-105.787 127.3-170.317a662.687 662.687 0 0 0 6.77-16.366c23.41-59.015 38.28-119.852 58.85-179.183a888.061 888.061 0 0 1 11.17-30.368c26.64-67.97 64.13-134.485 118.48-182.408 7.82-6.893 15.93-13.331 24.29-19.377 76.1-55.195 178.83-71.638 260.29-39.499 43.88 17.315 78.46 47.771 124.57 57.118",
    stroke: "#2E2E2E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M327.291 1057.95c50.334-78.358 132.757-132.125 216.496-155.941 60.613-17.239 122.061-19.895 182.029-12.787 21.494 2.517 42.761 6.274 63.762 10.688 66.467 13.976 131.48 34.529 200.742 36.818 68.11 2.238 140.95-14.153 201.93-58.674 57.69-42.155 99.34-105.408 127.38-169.621 2.37-5.414 4.63-10.84 6.83-16.291 23.67-58.711 38.91-119.257 59.82-178.272 3.58-10.081 7.34-20.161 11.34-30.204 27.03-67.603 64.91-133.676 119.47-180.928 7.86-6.805 16.01-13.141 24.39-19.086 76.3-54.26 178.48-69.551 260.01-37.931 43.85 16.999 78.68 46.696 124.71 55.613",
    stroke: "#313131"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M327.923 1061.74c49.929-78.392 131.683-132.652 215.105-157.264 60.31-17.796 121.619-21.122 181.524-14.609 21.481 2.302 42.735 5.869 63.736 10.081 66.467 13.356 131.531 33.314 200.679 34.984 67.943 1.644 140.343-15.292 201.043-59.787 57.44-42.155 99.17-105.028 127.46-168.926a620.169 620.169 0 0 0 6.89-16.202c23.91-58.408 39.53-118.675 60.78-177.362a851.32 851.32 0 0 1 11.52-30.026c27.44-67.223 65.68-132.866 120.47-179.449 7.9-6.716 16.07-12.951 24.48-18.794 76.51-53.324 178.11-67.464 259.74-36.363 43.81 16.695 78.9 45.634 124.86 54.12",
    stroke: "#333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M328.568 1065.52c49.525-78.415 130.62-133.181 213.701-158.578 60.007-18.339 121.176-22.362 181.018-16.417 21.469 2.1 42.711 5.451 63.712 9.473 66.467 12.737 131.569 32.101 200.615 33.151 67.786 1.037 139.736-16.417 200.146-60.9 57.2-42.143 98.98-104.649 127.55-168.243 2.4-5.363 4.72-10.725 6.97-16.113 24.16-58.105 40.14-118.094 61.74-176.464 3.7-9.98 7.58-19.946 11.69-29.862 27.83-66.857 66.47-132.057 121.47-177.969 7.94-6.628 16.14-12.762 24.58-18.504 76.73-52.388 177.75-65.365 259.48-34.795 43.79 16.38 79.11 44.559 125.01 52.616",
    stroke: "#353535"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M329.2 1069.32c49.107-78.459 129.558-133.705 212.298-159.899 59.703-18.896 120.721-23.588 180.512-18.238 21.444 1.884 42.685 5.046 63.686 8.866 66.467 12.117 131.62 30.886 200.565 31.329 67.619.43 139.119-17.555 199.259-62.013 56.95-42.143 98.8-104.282 127.63-167.547a631.769 631.769 0 0 0 7.03-16.038c24.41-57.801 40.76-117.499 62.7-175.553 3.75-9.929 7.7-19.832 11.86-29.697 28.22-66.49 67.25-131.248 122.46-176.477 7.98-6.539 16.22-12.572 24.68-18.213 76.95-51.452 177.41-63.277 259.22-33.226 43.76 16.063 79.34 43.496 125.15 51.123",
    stroke: "#383838"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M329.845 1073.1c48.703-78.482 128.496-134.235 210.895-161.213 59.399-19.439 120.278-24.827 179.994-20.059 21.43 1.669 42.659 4.642 63.66 8.272 66.467 11.497 131.67 29.28 200.502 29.495 67.454.202 138.514-18.681 198.374-63.126 56.7-42.143 98.61-103.903 127.7-166.864 2.44-5.3 4.81-10.625 7.1-15.949 24.65-57.498 41.38-116.918 63.66-174.643 3.82-9.865 7.81-19.731 12.03-29.533 28.62-66.123 68.03-130.438 123.46-174.997 8.01-6.45 16.29-12.395 24.76-17.934 77.17-50.516 177.05-61.179 258.96-31.671 43.72 15.759 79.55 42.434 125.3 49.631",
    stroke: "#3A3A3A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M330.477 1076.89c48.298-78.516 127.434-134.761 209.504-162.524 59.109-19.983 119.836-26.054 179.488-21.88 21.406 1.467 42.634 4.224 63.623 7.664 66.467 10.877 131.708 28.445 200.451 27.661 67.287-.771 137.907-19.819 197.477-64.239 56.46-42.13 98.43-103.523 127.79-166.168a626.328 626.328 0 0 0 7.17-15.873c24.91-57.194 42-116.336 64.62-173.745a845.85 845.85 0 0 1 12.22-29.356c29-65.744 68.8-129.628 124.45-173.517 8.05-6.349 16.36-12.205 24.87-17.643 77.36-49.58 176.68-59.079 258.68-30.103 43.7 15.444 79.77 41.359 125.45 48.126",
    stroke: "#3C3C3C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M331.122 1080.67c47.893-78.55 126.359-135.291 208.1-163.837 58.806-20.54 119.381-27.294 178.983-23.702 21.393 1.252 42.609 3.819 63.597 7.057 66.467 10.258 131.759 27.231 200.388 25.84 67.14-1.366 137.3-20.945 196.6-65.352 56.2-42.13 98.25-103.157 127.86-165.486 2.49-5.248 4.89-10.51 7.23-15.784 25.16-56.891 42.62-115.754 65.58-172.834a883.113 883.113 0 0 1 12.38-29.191c29.4-65.378 69.59-128.82 125.45-172.038 8.09-6.26 16.44-12.015 24.97-17.353 77.58-48.644 176.33-56.991 258.42-28.533 43.66 15.139 80 40.296 125.59 46.633",
    stroke: "#3E3E3E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M331.754 1084.47c47.477-78.58 125.298-135.815 206.697-165.158 58.502-21.084 118.938-28.521 178.477-25.524 21.38 1.037 42.583 3.402 63.572 6.451 66.467 9.637 131.809 26.016 200.337 24.005 66.973-1.973 136.693-22.083 195.713-66.465 55.96-42.13 98.06-102.777 127.95-164.789 2.5-5.224 4.94-10.46 7.3-15.709 25.4-56.587 43.24-115.16 66.54-171.923a847.672 847.672 0 0 1 12.55-29.027c29.79-65.011 70.38-128.01 126.45-170.558 8.14-6.172 16.51-11.826 25.06-17.062 77.8-47.708 175.98-54.892 258.16-26.965 43.63 14.823 80.21 39.221 125.74 45.128",
    stroke: "#414141"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M332.399 1088.25c47.072-78.62 124.235-136.345 205.293-166.472 58.211-21.628 118.496-29.761 177.971-27.332 21.355.835 42.559 2.997 63.547 5.843 66.467 9.018 131.847 24.803 200.274 22.172 66.806-2.568 136.066-23.222 194.816-67.578 55.7-42.118 97.88-102.398 128.03-164.094a745.636 745.636 0 0 0 7.37-15.62c25.65-56.284 43.84-114.578 67.5-171.026 4.06-9.65 8.28-19.288 12.73-28.85 30.18-64.643 71.15-127.2 127.45-169.077 8.18-6.084 16.58-11.636 25.16-16.771 78.01-46.772 175.61-52.793 257.89-25.397 43.6 14.52 80.43 38.159 125.89 43.635",
    stroke: "#434343"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M333.031 1092.04c46.667-78.64 123.174-136.859 203.903-167.783 57.907-22.172 118.053-30.987 177.465-29.153 21.342.619 42.533 2.592 63.521 5.236 66.468 8.398 131.898 23.601 200.224 20.338 66.646-3.175 135.466-24.348 193.926-68.704 55.47-42.117 97.7-102.031 128.11-163.411 2.55-5.16 5.03-10.346 7.43-15.544 25.91-55.98 44.47-113.996 68.47-170.115 4.1-9.6 8.39-19.174 12.9-28.686 30.58-64.264 71.93-126.378 128.44-167.597 8.22-5.995 16.65-11.447 25.26-16.481 78.21-45.836 175.25-50.692 257.63-23.841 43.57 14.204 80.65 37.084 126.03 42.13",
    stroke: "#454545"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M333.676 1095.83c46.262-78.69 122.111-137.398 202.499-169.107 57.604-22.715 117.598-32.214 176.947-30.974 21.33.417 42.508 2.175 63.496 4.629 66.455 7.778 131.948 22.387 200.161 18.516 66.481-3.769 134.851-25.485 193.041-69.816 55.22-42.118 97.52-101.652 128.19-162.716a672.467 672.467 0 0 0 7.5-15.456c26.15-55.676 45.09-113.414 69.43-169.204 4.17-9.549 8.52-19.06 13.07-28.521 30.97-63.897 72.71-125.568 129.43-166.118 8.26-5.906 16.73-11.256 25.35-16.189 78.43-44.9 174.9-48.593 257.36-22.273 43.54 13.9 80.87 36.021 126.19 40.638",
    stroke: "#484848"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M334.308 1099.62c45.858-78.72 121.049-137.912 201.096-170.418 57.313-23.259 117.155-33.453 176.441-32.796 21.305.203 42.47 1.771 63.471 4.022 66.455 7.159 131.986 21.173 200.11 16.683 66.324-4.376 134.254-26.611 192.144-70.93 54.97-42.117 97.34-101.272 128.27-162.032 2.59-5.11 5.12-10.232 7.57-15.38 26.4-55.373 45.71-112.82 70.39-168.306 4.24-9.499 8.64-18.959 13.25-28.344 31.36-63.531 73.5-124.759 130.43-164.638 8.3-5.818 16.8-11.08 25.45-15.899 78.65-43.964 174.53-46.493 257.08-20.704 43.51 13.584 81.09 34.946 126.33 39.132",
    stroke: "#4A4A4A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M334.953 1103.4c45.441-78.74 119.987-138.442 199.692-171.731 57.01-23.816 116.713-34.681 175.936-34.618 21.291 0 42.444 1.354 63.445 3.428 66.455 6.526 132.037 19.958 200.047 14.849 66.167-4.971 133.627-27.75 191.257-72.043 54.72-42.105 97.16-100.893 128.35-161.337a711.19 711.19 0 0 0 7.63-15.291c26.66-55.069 46.33-112.238 71.36-167.396 4.29-9.435 8.75-18.845 13.43-28.179 31.75-63.164 74.28-123.937 131.43-163.146a291.572 291.572 0 0 1 25.55-15.607c78.86-43.029 174.18-44.395 256.82-19.137 43.47 13.281 81.31 33.884 126.47 37.641",
    stroke: "#4C4C4C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M335.585 1107.2c45.036-78.79 118.925-138.966 198.302-173.052 56.706-24.347 116.27-35.92 175.429-36.439 21.267-.215 42.419.949 63.42 2.821 66.455 5.906 132.088 18.744 199.997 13.027 65.997-5.565 133.027-28.875 190.357-73.156 54.49-42.105 96.98-100.525 128.44-160.654a667.083 667.083 0 0 0 7.7-15.202c26.89-54.766 46.94-111.656 72.32-166.485 4.35-9.385 8.86-18.732 13.59-28.015 32.14-62.785 75.07-123.128 132.43-161.666 8.38-5.628 16.94-10.7 25.64-15.317 79.07-42.092 173.81-42.282 256.55-17.568 43.45 12.977 81.53 32.809 126.63 36.148",
    stroke: "#4F4F4F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M336.23 1110.98c44.632-78.82 117.863-139.483 196.898-174.366 56.416-24.891 115.815-37.147 174.924-38.247 21.254-.43 42.394.544 63.395 2.213 66.455 5.287 132.125 17.543 199.933 11.194 65.83-6.16 132.42-30.014 189.48-74.269 54.22-42.105 96.78-100.146 128.51-159.958a779.656 779.656 0 0 0 7.77-15.127c27.15-54.462 47.57-111.074 73.28-165.587 4.42-9.334 8.99-18.63 13.77-27.851 32.53-62.417 75.85-122.305 133.42-160.186 8.42-5.539 17.02-10.51 25.74-15.025 79.28-41.157 173.46-40.183 256.29-16.013 43.4 12.674 81.75 31.747 126.76 34.643",
    stroke: "#515151"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M336.862 1114.77c44.227-78.84 116.801-139.997 195.495-175.677 56.112-25.435 115.372-38.386 174.405-40.069 21.242-.645 42.369.127 63.37 1.607 66.455 4.667 132.176 16.328 199.882 9.359 65.666-6.754 131.806-31.139 188.596-75.382 53.98-42.092 96.61-99.766 128.59-159.262 2.68-4.996 5.3-10.017 7.84-15.039 27.4-54.158 48.19-110.479 74.25-164.676 4.46-9.283 9.1-18.516 13.94-27.673 32.93-62.051 76.63-121.484 134.42-158.707 8.45-5.451 17.08-10.32 25.83-14.734 79.49-40.221 173.09-38.083 256.02-14.444 43.38 12.357 81.96 30.671 126.91 33.15",
    stroke: "#535353"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M337.507 1118.55c43.822-78.88 115.739-140.514 194.091-176.991 55.822-25.979 114.93-39.613 173.9-41.89 21.216-.847 42.343-.278 63.344 1 66.455 4.047 132.227 15.114 199.819 7.525 65.519-7.348 131.199-32.277 187.699-76.495 53.73-42.092 96.42-99.4 128.67-158.579 2.7-4.971 5.33-9.954 7.9-14.963 27.65-53.855 48.81-109.898 75.21-163.765 4.52-9.221 9.21-18.403 14.12-27.509 33.33-61.684 77.41-120.674 135.41-157.227 8.5-5.363 17.16-10.131 25.93-14.444 79.71-39.284 172.74-35.97 255.76-12.875 43.34 12.053 82.18 29.608 127.07 31.645",
    stroke: "#565656"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M338.139 1122.35c43.405-78.91 114.677-141.038 192.701-178.312 55.518-26.522 114.475-40.84 173.394-43.711 21.203-1.062 42.318-.683 63.319.392 66.454 3.428 132.264 13.913 199.768 5.704a375.772 375.772 0 0 0 186.809-77.607c53.5-42.093 96.24-99.021 128.75-157.884 2.72-4.946 5.39-9.904 7.98-14.874 27.89-53.552 49.42-109.316 76.16-162.868 4.59-9.169 9.33-18.301 14.29-27.345 33.72-61.304 78.2-119.851 136.41-155.746 8.55-5.262 17.23-9.941 26.03-14.153 79.92-38.349 172.37-33.871 255.49-11.307 43.31 11.75 82.41 28.533 127.21 30.152",
    stroke: "#585858"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M338.784 1126.13c43-78.95 113.628-141.555 191.297-179.625 55.227-27.067 114.032-42.08 172.888-45.533 21.191-1.277 42.293-1.1 63.281-.215 66.455 2.808 132.315 12.699 199.706 3.87 65.194-8.55 129.974-34.541 185.924-78.72 53.24-42.08 96.07-98.642 128.84-157.201 2.74-4.92 5.42-9.853 8.04-14.798 28.14-53.248 50.04-108.735 77.12-161.957a805.936 805.936 0 0 1 14.47-27.168c34.11-60.938 78.98-119.03 137.4-154.267 8.58-5.173 17.31-9.764 26.12-13.875 80.12-37.412 172.01-31.759 255.22-9.738 43.28 11.446 82.63 27.471 127.36 28.647",
    stroke: "#5A5A5A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M339.416 1129.93c42.596-78.99 112.566-142.079 189.894-180.946 54.923-27.598 113.59-43.307 172.382-47.354 21.166-1.48 42.268-1.505 63.256-.822 66.455 2.188 132.366 11.497 199.655 2.036 65.027-9.144 129.367-35.68 185.027-79.834 53-42.079 95.88-98.261 128.91-156.505 2.77-4.882 5.48-9.79 8.12-14.71 28.4-52.944 50.65-108.139 78.09-161.046 4.7-9.068 9.57-18.074 14.64-27.003 34.5-60.571 79.78-118.22 138.39-152.787 8.63-5.084 17.38-9.574 26.23-13.584 80.33-36.477 171.65-29.647 254.96-8.183 43.24 11.143 82.84 26.396 127.51 27.155",
    stroke: "#5D5D5D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M340.061 1133.71c42.191-79.01 111.503-142.596 188.49-182.26 54.633-28.142 113.147-44.546 171.864-49.175 21.153-1.695 42.242-1.922 63.231-1.417 66.454 1.569 132.416 10.296 199.591.215 64.873-9.726 128.763-36.805 184.143-80.946 52.75-42.08 95.7-97.895 129-155.81 2.8-4.857 5.51-9.739 8.18-14.634 28.64-52.64 51.27-107.558 79.05-160.148 4.77-9.005 9.68-17.96 14.8-26.839 34.9-60.204 80.57-117.398 139.4-151.307 8.66-4.996 17.45-9.385 26.32-13.293 80.56-35.541 171.29-27.534 254.7-6.615 43.21 10.84 83.06 25.334 127.65 25.663",
    stroke: "#5F5F5F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M340.693 1137.5c41.787-79.05 110.454-143.11 187.1-183.571 54.342-28.685 112.692-45.773 171.358-50.984 21.14-1.909 42.217-2.327 63.205-2.023 66.455.948 132.454 9.081 199.541-1.619 64.713-10.321 128.143-37.944 183.253-82.06 52.51-42.067 95.51-97.516 129.08-155.127 2.81-4.831 5.56-9.675 8.25-14.545 28.89-52.337 51.88-106.976 80-159.237 4.82-8.955 9.8-17.859 14.99-26.675 35.28-59.825 81.35-116.576 140.39-149.827 8.7-4.908 17.52-9.195 26.41-13.002 80.77-34.605 170.93-25.423 254.43-5.047 43.18 10.536 83.28 24.259 127.8 24.158",
    stroke: "#616161"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M341.338 1141.28c41.369-79.07 109.392-143.627 185.696-184.884 54.039-29.217 112.25-47.013 170.853-52.806 21.114-2.112 42.191-2.732 63.18-2.63 66.454.328 132.529 8.006 199.477-3.453 64.566-10.802 127.536-39.07 182.356-83.173 52.26-42.067 95.34-97.136 129.16-154.431 2.83-4.806 5.6-9.625 8.32-14.469 29.14-52.034 52.5-106.382 80.97-158.327a801.85 801.85 0 0 1 15.16-26.498c35.68-59.458 82.13-115.754 141.39-148.335 8.75-4.806 17.59-9.005 26.51-12.711 80.97-33.669 170.56-23.31 254.15-3.478 43.14 10.232 83.5 23.196 127.95 22.665",
    stroke: "#646464"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M341.97 1145.08c40.965-79.12 108.33-144.14 184.293-186.206 53.747-29.76 111.807-48.239 170.346-54.626 21.103-2.327 42.167-3.149 63.155-3.238 66.455-.291 132.581 6.792 199.427-5.274 64.409-11.396 126.929-40.208 181.469-84.299 52.01-42.067 95.16-96.769 129.25-153.748 2.85-4.781 5.65-9.574 8.38-14.38 29.38-51.73 53.13-105.8 81.93-157.429a835.5 835.5 0 0 1 15.32-26.333c36.08-59.091 82.92-114.932 142.38-146.855 8.79-4.718 17.67-8.816 26.62-12.421 81.18-32.732 170.21-21.197 253.88-1.909 43.12 9.928 83.73 22.121 128.09 21.16",
    stroke: "#666"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M342.615 1148.86c40.56-79.15 107.356-144.52 182.889-187.519 53.508-30.204 111.365-49.466 169.841-56.448 21.077-2.53 42.141-3.554 63.13-3.845 66.454-.911 132.618 5.578 199.364-7.108 64.251-12.003 126.321-41.334 180.591-85.412 51.76-42.067 94.96-96.389 129.32-153.052 2.87-4.743 5.68-9.511 8.44-14.292 29.64-51.427 53.75-105.218 82.89-156.518 5-8.791 10.16-17.53 15.5-26.169 36.47-58.724 83.72-114.11 143.38-145.375 8.83-4.629 17.74-8.626 26.7-12.13 81.4-31.796 169.85-19.085 253.62-.354 43.08 9.638 83.94 21.059 128.25 19.668",
    stroke: "#686868"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M343.247 1152.65c40.156-79.17 106.294-145.03 181.498-188.83 53.217-30.747 110.91-50.706 169.323-58.269 21.064-2.745 42.116-3.972 63.104-4.452 66.455-1.531 132.669 4.363 199.301-8.942 64.087-12.598 125.717-42.472 179.687-86.525 51.51-42.054 94.79-96.01 129.4-152.37 2.89-4.717 5.74-9.46 8.52-14.216 29.89-51.123 54.37-104.636 83.85-155.62 5.06-8.74 10.27-17.416 15.68-25.991 36.86-58.345 84.55-113.161 144.38-143.896a265.487 265.487 0 0 1 26.8-11.838c81.62-30.861 169.48-16.974 253.35 1.214 43.05 9.334 84.16 19.984 128.4 18.162",
    stroke: "#6A6A6A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M343.892 1156.44c39.751-79.22 105.232-145.57 180.095-190.154 52.913-31.291 110.467-51.932 168.817-60.09 21.051-2.96 42.078-4.376 63.079-5.059 66.454-2.151 132.719 3.149 199.25-10.776 63.927-13.205 125.097-43.61 178.807-87.638 51.27-42.054 94.6-95.631 129.48-151.674a847.75 847.75 0 0 0 8.59-14.128c30.13-50.819 54.98-104.041 84.81-154.709 5.12-8.689 10.38-17.302 15.85-25.827 37.25-57.978 85.34-112.352 145.38-142.416a261.447 261.447 0 0 1 26.91-11.547c81.83-29.925 169.08-14.697 253.08 2.782 43 9.119 84.39 18.922 128.54 16.67",
    stroke: "#6D6D6D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M344.524 1160.23c39.334-79.24 104.17-146.1 178.692-191.465 52.61-31.847 110.024-53.172 168.311-61.899 21.026-3.162 42.052-4.781 63.053-5.666 66.455-2.77 132.771 1.935 199.187-12.597 63.773-13.799 124.493-44.736 177.923-88.751 51.01-42.054 94.42-95.264 129.56-150.978 2.93-4.667 5.83-9.347 8.64-14.052 30.39-50.516 55.61-103.46 85.78-153.799a798.397 798.397 0 0 1 16.02-25.663c37.64-57.611 86.11-111.542 146.37-140.935 8.95-4.339 17.96-8.07 27-11.257 82.03-28.989 168.73-12.597 252.82 4.351 42.96 8.803 84.6 17.846 128.68 15.177",
    stroke: "#6F6F6F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M345.169 1164.01c38.929-79.28 103.108-146.63 177.288-192.779 52.319-32.391 109.582-54.398 167.806-63.72 21.013-3.377 42.027-5.198 63.028-6.26 66.442-3.39 132.821.72 199.136-14.432 63.613-14.406 123.883-45.874 177.023-89.863 50.78-42.042 94.23-94.885 129.65-150.296 2.96-4.641 5.86-9.296 8.72-13.963 30.64-50.212 56.23-102.878 86.74-152.901a795.748 795.748 0 0 1 16.19-25.485c38.03-57.245 86.89-110.72 147.36-139.456 8.99-4.25 18.03-7.88 27.1-10.966 82.25-28.053 168.37-10.498 252.55 5.906 42.94 8.5 84.82 16.784 128.83 13.673",
    stroke: "#717171"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M345.801 1167.81c38.525-79.32 102.059-147.15 175.897-194.099 52.016-32.936 109.127-55.639 167.3-65.542 21.001-3.592 42.002-5.603 63.003-6.868 66.442-4.009 132.859-.493 199.073-16.265 63.446-15.001 123.276-47 176.136-90.977 50.53-42.041 94.06-94.505 129.72-149.599a699.84 699.84 0 0 0 8.79-13.888c30.88-49.908 56.85-102.296 87.7-151.99 5.3-8.525 10.73-16.973 16.37-25.321 38.43-56.865 87.67-109.911 148.36-137.976 9.04-4.149 18.09-7.69 27.2-10.675 82.46-27.117 168.02-8.398 252.29 7.475 42.9 8.183 85.04 15.709 128.97 12.18",
    stroke: "#747474"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M346.433 1171.59c38.12-79.34 100.997-147.68 174.494-195.413 51.725-33.492 108.684-56.865 166.794-67.363 20.976-3.795 41.977-6.021 62.978-7.475 66.442-4.629 132.909-1.708 199.022-18.087 63.279-15.607 122.659-48.138 175.249-92.089 50.29-42.042 93.88-94.139 129.8-148.917 3.01-4.579 5.96-9.182 8.85-13.799 31.13-49.605 57.46-101.702 88.66-151.079a792.414 792.414 0 0 1 16.54-25.157c38.81-56.498 88.45-109.101 149.36-136.497 9.07-4.06 18.17-7.5 27.28-10.384 82.68-26.181 167.66-6.298 252.03 9.044 42.87 7.879 85.25 14.646 129.12 10.675",
    stroke: "#767676"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M347.078 1175.38c37.716-79.38 99.935-148.21 173.09-196.724 51.422-34.036 108.242-58.092 166.276-69.184 20.963-4.01 41.952-6.426 62.94-8.082 66.442-5.249 132.96-2.922 198.959-19.921 63.127-16.202 122.047-49.264 174.357-93.203 50.03-42.029 93.69-93.759 129.89-148.221 3.02-4.553 6-9.131 8.92-13.723 31.38-49.301 58.07-101.12 89.62-150.181a791.875 791.875 0 0 1 16.71-24.992c39.22-56.132 89.23-108.279 150.36-135.004a252.986 252.986 0 0 1 27.39-10.093c82.88-25.246 167.3-4.2 251.76 10.611 42.85 7.564 85.47 13.571 129.26 9.183",
    stroke: "#787878"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M347.71 1179.16c37.299-79.4 98.873-148.72 171.687-198.038 51.131-34.579 107.787-59.331 165.77-71.005 20.938-4.225 41.926-6.83 62.915-8.69 66.442-5.868 133.01-4.135 198.908-21.754 62.97-16.809 121.44-50.402 173.47-94.316 49.79-42.029 93.51-93.379 129.96-147.525 3.05-4.528 6.05-9.069 8.99-13.635 31.62-48.998 58.69-100.538 90.58-149.27 5.48-8.361 11.09-16.645 16.89-24.816 39.62-55.764 90.01-107.469 151.35-133.524a250.391 250.391 0 0 1 27.48-9.815c83.1-24.309 166.95-2.099 251.5 12.18 42.81 7.26 85.7 12.509 129.42 7.678",
    stroke: "#7B7B7B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M348.355 1182.96c62.775-135.15 195.04-242.438 335.56-272.173 87.165-18.453 175.164-8.879 261.748-32.872 127.957-35.465 236.067-140.341 311.677-255.83 37.35-57.042 68.6-117.625 108.6-173.011 40-55.385 90.79-106.66 152.34-132.044 134.65-55.537 268.84 27.193 408.36 10.409",
    stroke: "#7D7D7D"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m.078 1068.44 758.614-.32 758.618.32-758.618.31-758.614-.31Z",
    fill: "url(#exchange-sub-account-bg_svg__c)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 1049.92 758.614-.32 758.618.32-758.618.32-758.614-.32Z",
    fill: "url(#exchange-sub-account-bg_svg__d)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 1031.39 758.614-.32 758.618.32-758.618.32-758.614-.32Z",
    fill: "url(#exchange-sub-account-bg_svg__e)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 1012.87 758.614-.31 758.618.31-758.618.31-758.614-.31Z",
    fill: "url(#exchange-sub-account-bg_svg__f)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 994.345 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__g)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 975.816 758.614-.304 758.618.304-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__h)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 957.299 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__i)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 938.77 758.614-.316 758.618.316-758.618.316L.078 938.77Z",
    fill: "url(#exchange-sub-account-bg_svg__j)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 920.253 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__k)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 901.724 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__l)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 883.208 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__m)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 864.679 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__n)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 846.162 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__o)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 827.633 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__p)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 809.116 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__q)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 790.587 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__r)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 772.07 758.614-.316 758.618.316-758.618.316L.078 772.07Z",
    fill: "url(#exchange-sub-account-bg_svg__s)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 753.541 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__t)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 735.024 758.614-.316 758.618.316-758.618.304-758.614-.304Z",
    fill: "url(#exchange-sub-account-bg_svg__u)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 716.495 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__v)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 697.966 758.614-.303 758.618.303-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__w)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 679.449 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__x)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 660.92 758.614-.316 758.618.316-758.618.316L.078 660.92Z",
    fill: "url(#exchange-sub-account-bg_svg__y)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 642.404 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__z)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 623.875 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__A)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 605.358 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__B)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 586.829 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__C)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 568.312 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__D)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 549.783 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__E)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 531.266 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__F)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 512.737 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__G)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 494.22 758.614-.316 758.618.316-758.618.317L.078 494.22Z",
    fill: "url(#exchange-sub-account-bg_svg__H)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 475.691 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__I)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 457.175 758.614-.316 758.618.316-758.618.303-758.614-.303Z",
    fill: "url(#exchange-sub-account-bg_svg__J)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 438.646 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__K)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 420.116 758.614-.303 758.618.303-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__L)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 401.6 758.614-.316 758.618.316-758.618.316L.078 401.6Z",
    fill: "url(#exchange-sub-account-bg_svg__M)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 383.071 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__N)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 364.554 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__O)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 346.025 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__P)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 327.508 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__Q)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 308.979 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__R)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 290.462 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__S)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 271.933 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__T)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 253.417 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__U)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 234.887 758.614-.316 758.618.316-758.618.317-758.614-.317Z",
    fill: "url(#exchange-sub-account-bg_svg__V)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 216.371 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__W)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 197.842 758.614-.317 758.618.317-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__X)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 179.325 758.614-.316 758.618.316-758.618.304-758.614-.304Z",
    fill: "url(#exchange-sub-account-bg_svg__Y)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 160.796 758.614-.316 758.618.316-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__Z)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.078 142.267 758.614-.304 758.618.304-758.618.316-758.614-.316Z",
    fill: "url(#exchange-sub-account-bg_svg__aa)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M55.671 59.46v647.41l145.212 116.867v158.289l98.481 82.794V1247",
    stroke: "url(#exchange-sub-account-bg_svg__ab)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M69.668 52.72v647.409l145.224 116.867v158.289l98.468 82.795v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__ac)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M83.664 45.978v647.41l145.224 116.854v158.289l98.469 82.809v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__ad)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M97.673 39.237v647.396L242.885 803.5v158.289l98.468 82.811v182.16",
    stroke: "url(#exchange-sub-account-bg_svg__ae)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M111.67 32.483v647.409l145.211 116.867v158.289l98.468 82.792v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__af)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M125.666 25.741v647.41l145.212 116.867v158.289l98.468 82.793v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__ag)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M139.663 19v647.41l145.211 116.854v158.289l98.481 82.807v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__ah)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M153.659 48.09v611.578l145.212 116.854v158.289l98.48 82.809v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__ai)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.656 39.237v613.677l145.211 116.867V928.07l98.481 82.81v182.16",
    stroke: "url(#exchange-sub-account-bg_svg__aj)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M181.652 61.598v584.575L326.876 763.04v158.288l98.468 82.792v182.18",
    stroke: "url(#exchange-sub-account-bg_svg__ak)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M30.056 955.124c-1.43-1.442-1.43-3.782.012-5.211 1.442-1.429 3.78-1.429 5.21.013 1.428 1.441 1.428 3.781-.013 5.21-1.442 1.43-3.78 1.43-5.21-.012Z",
    fill: "#B8B8B8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M30.056 975.5c-1.43-1.442-1.43-3.782.012-5.211 1.442-1.43 3.78-1.43 5.21.012 1.428 1.442 1.428 3.782-.013 5.211-1.442 1.429-3.78 1.429-5.21-.012Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M30.056 995.888c-1.43-1.442-1.43-3.782.012-5.211 1.442-1.429 3.78-1.429 5.21.013 1.428 1.442 1.428 3.781-.013 5.211-1.442 1.429-3.78 1.429-5.21-.013Z",
    fill: "#B8B8B8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M30.056 1016.28c-1.43-1.45-1.43-3.79.012-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.44 1.428 3.78-.013 5.21-1.442 1.43-3.78 1.43-5.21-.01Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M30.056 1036.65c-1.43-1.44-1.43-3.78.012-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.45 1.428 3.79-.013 5.22-1.442 1.42-3.78 1.42-5.21-.02ZM30.056 1057.04c-1.43-1.44-1.43-3.78.012-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.44 1.428 3.78-.013 5.21-1.442 1.43-3.78 1.43-5.21-.01Z",
    fill: "#B8B8B8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M30.056 1077.43c-1.43-1.44-1.43-3.78.012-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.44 1.428 3.78-.013 5.21-1.442 1.43-3.78 1.43-5.21-.01Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M50.652 975.715c-1.429-1.442-1.429-3.782.013-5.211 1.441-1.43 3.78-1.43 5.209.012 1.428 1.442 1.428 3.782-.013 5.211-1.441 1.429-3.78 1.429-5.209-.012Z",
    fill: "#B8B8B8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M50.652 996.103c-1.429-1.442-1.429-3.782.013-5.211 1.441-1.429 3.78-1.429 5.209.013 1.428 1.442 1.428 3.781-.013 5.211-1.441 1.429-3.78 1.429-5.209-.013Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M50.652 1016.48c-1.429-1.44-1.429-3.78.013-5.21 1.441-1.43 3.78-1.43 5.209.01 1.428 1.44 1.428 3.78-.013 5.21-1.441 1.43-3.78 1.43-5.209-.01Z",
    fill: "#B8B8B8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M50.652 1036.87c-1.429-1.44-1.429-3.78.013-5.21 1.441-1.43 3.78-1.43 5.209.01 1.428 1.44 1.428 3.78-.013 5.21-1.441 1.43-3.78 1.43-5.209-.01Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M50.652 1057.26c-1.429-1.45-1.429-3.79.013-5.22 1.441-1.42 3.78-1.42 5.209.02 1.428 1.44 1.428 3.78-.013 5.21-1.441 1.43-3.78 1.43-5.209-.01ZM50.652 1077.64c-1.429-1.44-1.429-3.78.013-5.21 1.441-1.43 3.78-1.43 5.209.02 1.428 1.44 1.428 3.78-.013 5.21-1.441 1.43-3.78 1.43-5.209-.02ZM94.348 1050.74c-1.429-1.44-1.429-3.78.013-5.21 1.441-1.43 3.78-1.43 5.209.01 1.429 1.45 1.429 3.79-.013 5.21-1.441 1.43-3.78 1.43-5.209-.01ZM94.348 1071.13c-1.429-1.44-1.429-3.78.013-5.21 1.441-1.43 3.78-1.43 5.209.01 1.429 1.44 1.429 3.78-.013 5.21-1.441 1.43-3.78 1.43-5.209-.01Z",
    fill: "#B8B8B8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M72.12 1026.67c-1.428-1.44-1.428-3.78.013-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.45 1.428 3.79-.013 5.22-1.442 1.42-3.78 1.43-5.21-.02Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M72.12 1047.06c-1.428-1.44-1.428-3.78.013-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.45 1.428 3.79-.013 5.21-1.442 1.43-3.78 1.43-5.21-.01ZM72.12 1067.45c-1.428-1.44-1.428-3.78.013-5.21 1.442-1.43 3.78-1.43 5.21.01 1.428 1.44 1.428 3.78-.013 5.21-1.442 1.43-3.78 1.43-5.21-.01Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1054.17 294.307a5.74 5.74 0 0 1-6.13 5.325c-3.16-.227-5.55-2.972-5.32-6.134.23-3.162 2.97-5.552 6.13-5.325a5.75 5.75 0 0 1 5.32 6.134Z",
    fill: "url(#exchange-sub-account-bg_svg__al)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1131.79 338.778c-.38 5.236-4.92 9.169-10.14 8.79-5.23-.38-9.17-4.92-8.79-10.144.38-5.223 4.92-9.17 10.14-8.79 5.24.379 9.17 4.92 8.79 10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__am)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1054.17 560.394a5.738 5.738 0 0 0-6.13-5.324c-3.16.227-5.55 2.972-5.32 6.134.23 3.162 2.97 5.552 6.13 5.325a5.75 5.75 0 0 0 5.32-6.135Z",
    fill: "url(#exchange-sub-account-bg_svg__an)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1131.79 515.912c-.38-5.236-4.92-9.17-10.14-8.791-5.23.38-9.17 4.921-8.79 10.144.38 5.224 4.92 9.17 10.14 8.79 5.24-.379 9.17-4.92 8.79-10.143Z",
    fill: "url(#exchange-sub-account-bg_svg__ao)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M262.988 290.159c-.379 5.236-4.918 9.17-10.14 8.79-5.222-.379-9.167-4.92-8.787-10.143.379-5.237 4.918-9.17 10.14-8.791 5.234.38 9.166 4.92 8.787 10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__ap)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M670.465 853.422a6.054 6.054 0 0 0-6.461-5.603c-3.325.24-5.828 3.124-5.601 6.463a6.056 6.056 0 0 0 6.461 5.603 6.055 6.055 0 0 0 5.601-6.463Z",
    fill: "url(#exchange-sub-account-bg_svg__aq)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M752.117 806.637c-.391-5.502-5.171-9.65-10.671-9.258-5.5.392-9.647 5.173-9.255 10.675.392 5.502 5.171 9.65 10.671 9.258 5.5-.392 9.647-5.173 9.255-10.675Z",
    fill: "url(#exchange-sub-account-bg_svg__ar)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1299.67 252.936a5.74 5.74 0 0 1-6.13 5.325c-3.16-.228-5.55-2.972-5.32-6.134.23-3.162 2.97-5.553 6.13-5.325a5.75 5.75 0 0 1 5.32 6.134Z",
    fill: "url(#exchange-sub-account-bg_svg__as)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1426.63 273.894c-.38 5.236-4.92 9.169-10.14 8.79-5.24-.379-9.17-4.92-8.79-10.144.38-5.223 4.92-9.169 10.14-8.79 5.23.38 9.17 4.92 8.79 10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__at)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1349.01 560.394c-.23-3.162-2.97-5.552-6.13-5.324-3.16.227-5.54 2.972-5.33 6.134.23 3.162 2.97 5.552 6.14 5.325 3.16-.228 5.55-2.973 5.32-6.135Z",
    fill: "url(#exchange-sub-account-bg_svg__au)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1349.01 1015.56c-.23-3.17-2.97-5.56-6.13-5.33a5.766 5.766 0 0 0-5.33 6.14c.23 3.16 2.97 5.55 6.14 5.32 3.16-.23 5.55-2.97 5.32-6.13Z",
    fill: "url(#exchange-sub-account-bg_svg__av)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1402.01 643.745c-.38-5.237-4.92-9.17-10.14-8.791-5.23.38-9.17 4.92-8.79 10.144.38 5.223 4.92 9.17 10.14 8.79 5.22-.379 9.17-4.92 8.79-10.143Z",
    fill: "url(#exchange-sub-account-bg_svg__aw)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1303.42 784.554c-.38-5.236-4.92-9.17-10.14-8.79-5.24.379-9.17 4.92-8.79 10.143.38 5.236 4.92 9.17 10.14 8.79 5.22-.379 9.16-4.92 8.79-10.143Z",
    fill: "url(#exchange-sub-account-bg_svg__ax)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1008.57 390.495c-.38 5.236-4.92 9.17-10.143 8.79-5.234-.379-9.167-4.92-8.787-10.143.379-5.236 4.918-9.17 10.14-8.791 5.23.38 9.17 4.921 8.79 10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__ay)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1008.57 464.194c-.38-5.236-4.92-9.169-10.143-8.79-5.234.38-9.167 4.92-8.787 10.144.379 5.236 4.918 9.17 10.14 8.79 5.23-.379 9.17-4.92 8.79-10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__az)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M139.764 341.876c-.38 5.236-4.919 9.17-10.14 8.791-5.235-.38-9.167-4.921-8.788-10.144.38-5.236 4.919-9.17 10.14-8.79 5.235.379 9.167 4.92 8.788 10.143Z",
    fill: "url(#exchange-sub-account-bg_svg__aA)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M622.483 674.694c-.392 5.502-5.171 9.65-10.671 9.258-5.5-.392-9.647-5.173-9.255-10.675.392-5.502 5.171-9.65 10.671-9.258 5.5.392 9.647 5.173 9.255 10.675Z",
    fill: "url(#exchange-sub-account-bg_svg__aB)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M622.483 752.226c-.392-5.502-5.171-9.651-10.671-9.258-5.5.392-9.647 5.173-9.255 10.674.392 5.502 5.171 9.651 10.671 9.259 5.5-.392 9.647-5.173 9.255-10.675Z",
    fill: "url(#exchange-sub-account-bg_svg__aC)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1414.33 435.876c-.38 5.236-4.92 9.169-10.14 8.79-5.23-.379-9.17-4.92-8.79-10.144.36-5.236 4.92-9.169 10.14-8.79 5.22.38 9.16 4.92 8.79 10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__aD)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1303.42 495.953c-.38-5.236-4.92-9.169-10.14-8.79-5.24.379-9.17 4.92-8.79 10.144.38 5.236 4.92 9.169 10.14 8.79 5.23-.379 9.16-4.92 8.79-10.144Z",
    fill: "url(#exchange-sub-account-bg_svg__aE)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M60.91 1032.35c10.192-4.22 15.033-15.91 10.81-26.11-4.222-10.197-15.907-15.039-26.1-10.816-10.194 4.224-15.034 15.916-10.812 26.106 4.222 10.2 15.908 15.04 26.101 10.82Z",
    fill: "url(#exchange-sub-account-bg_svg__aF)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(81.896 218.565 -66.491) scale(1563.11 2354.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#220049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.91 -74.368 1046.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912 -74.368 1046.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912 -74.368 1046.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.7 -74.368 1046.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 1046.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.7 -74.368 927.962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 927.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 927.961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 927.962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.47 -74.368 927.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.47 -74.368 927.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 809.725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 809.723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 809.724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 809.724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 809.724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.47 -74.368 809.722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 809.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.7 -74.368 691.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.47 -74.368 691.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.34 -74.368 691.489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 691.487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 691.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.47 -74.368 691.484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 573.251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 573.249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 573.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 573.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 573.251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 573.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.47 -74.368 573.246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 455.013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 455.013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.64 -74.368 455.013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 455.013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.35 -74.368 455.015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.75 -74.368 455.012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 336.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.75 -74.368 336.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 336.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.1 -74.368 336.776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5912.04 -74.368 336.776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 336.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.75 -74.368 218.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.9 -74.368 218.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.82 -74.368 218.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.9 -74.368 218.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.96 -74.368 218.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.79 -74.368 218.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.9 -74.368 218.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.63218 0 0 5911.79 -74.368 100.302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.72567 .40855 -.40869 5.72758 1048.4 293.821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47128 .67582 -.67605 9.4745 1122.28 338.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.72567 -.40855 .40869 5.72758 1048.22 560.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47128 -.67582 .67605 9.4745 1122.1 516.526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47126 .67582 -.67605 9.4745 253.516 289.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.02831 -.43015 .4303 6.0304 664.217 853.748)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.96313 -.71091 .71115 9.9665 741.937 807.246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.72571 .40855 -.40868 5.72758 1293.9 252.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47135 .67582 -.67604 9.4745 1417.12 273.113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.72565 -.40855 .40869 5.72758 1343.05 560.738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.72565 -.40855 .40869 5.7276 1343.03 1015.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47127 -.67582 .67605 9.4745 1392.3 644.361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47128 -.67582 .67605 9.4745 1293.69 785.159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47128 .67582 -.67605 9.4745 999.073 389.738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47128 -.67582 .67605 9.4745 998.882 464.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47126 .67582 -.67605 9.4745 130.297 341.163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.9631 .71091 -.71116 9.96651 612.521 673.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.9631 -.7109 .71115 9.96646 612.314 752.829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47129 .67582 -.67605 9.4745 1404.81 435.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.47128 -.67582 .67605 9.4745 1293.71 496.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "exchange-sub-account-bg_svg__aF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.9769 0 0 19.9837 53.261 1013.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ADADAD",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#636363",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2D2D2D",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0C0C0C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ab",
    x1: 177.518,
    y1: 59.461,
    x2: 177.518,
    y2: 1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ac",
    x1: 191.514,
    y1: 52.719,
    x2: 191.514,
    y2: 1240.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ad",
    x1: 205.51,
    y1: 45.978,
    x2: 205.51,
    y2: 1233.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ae",
    x1: 219.507,
    y1: 39.237,
    x2: 219.507,
    y2: 1226.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__af",
    x1: 233.516,
    y1: 32.483,
    x2: 233.516,
    y2: 1220.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ag",
    x1: 247.512,
    y1: 25.741,
    x2: 247.512,
    y2: 1213.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ah",
    x1: 261.509,
    y1: 19,
    x2: 261.509,
    y2: 1206.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ai",
    x1: 275.505,
    y1: 48.09,
    x2: 275.505,
    y2: 1199.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__aj",
    x1: 289.502,
    y1: 39.237,
    x2: 289.502,
    y2: 1193.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exchange-sub-account-bg_svg__ak",
    x1: 303.498,
    y1: 61.598,
    x2: 303.498,
    y2: 1186.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exchange-sub-account-bg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1620v1080H0z"
  })))));
};
export default SvgExchangeSubAccountBg;